var _defs, _path, _path2, _path3, _g, _g2, _g3, _g4, _path4, _path5, _path6, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _path7, _path8, _path9, _path10, _path11, _path12, _g23, _g24, _path13, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g52, _g53, _g54, _g55, _path28, _path29, _path30, _g56, _g57, _g58, _g59, _path31, _path32, _path33, _g60, _g61, _g62, _path34, _path35, _path36, _g63, _g64, _g65, _path37, _path38, _path39, _path40, _path41, _g66, _g67, _g68, _path42, _path43, _path44, _path45, _path46, _path47, _g69, _g70, _g71, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWtzcall002(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "141.98px",
    height: "291.633px",
    viewBox: "20.48 14.125 141.98 291.633",
    id: "svg186",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -4.953125 -2.109375 L 0 -2.109375 L 0 -1.53125 L -3.71875 -1.53125 L -3.71875 -0.46875 L -4.140625 -0.46875 C -4.160156 -0.945312 -4.238281 -1.269531 -4.375 -1.4375 C -4.507812 -1.601562 -4.703125 -1.6875 -4.953125 -1.6875 Z M -4.953125 -2.109375 ",
    id: "path1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -4.953125 -2.59375 L -1.703125 -2.59375 L -1.703125 -3.15625 L -1.203125 -3.15625 L -1.203125 -2.59375 L 0 -2.59375 L 0 -2 L -1.203125 -2 L -1.203125 -0.203125 L -1.75 -0.203125 L -4.953125 -2 Z M -1.703125 -0.734375 L -1.703125 -2 L -3.984375 -2 L -3.984375 -1.984375 Z M -1.703125 -0.734375 ",
    id: "path2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.84375 -1.921875 C -3.84375 -2.160156 -3.796875 -2.34375 -3.703125 -2.46875 C -3.609375 -2.59375 -3.457031 -2.679688 -3.25 -2.734375 C -3.425781 -2.828125 -3.566406 -2.953125 -3.671875 -3.109375 C -3.785156 -3.273438 -3.84375 -3.445312 -3.84375 -3.625 C -3.84375 -3.976562 -3.75 -4.226562 -3.5625 -4.375 C -3.382812 -4.53125 -3.117188 -4.609375 -2.765625 -4.609375 L 0 -4.609375 L 0 -4.03125 L -2.625 -4.03125 C -2.863281 -4.03125 -3.039062 -3.988281 -3.15625 -3.90625 C -3.28125 -3.820312 -3.34375 -3.691406 -3.34375 -3.515625 C -3.34375 -3.316406 -3.273438 -3.148438 -3.140625 -3.015625 C -3.015625 -2.890625 -2.835938 -2.828125 -2.609375 -2.828125 L 0 -2.828125 L 0 -2.234375 L -2.625 -2.234375 C -3.101562 -2.234375 -3.34375 -2.066406 -3.34375 -1.734375 C -3.34375 -1.523438 -3.273438 -1.351562 -3.140625 -1.21875 C -3.015625 -1.09375 -2.835938 -1.03125 -2.609375 -1.03125 L 0 -1.03125 L 0 -0.4375 L -3.75 -0.4375 L -3.75 -1 L -3.3125 -1 L -3.3125 -1.015625 C -3.476562 -1.097656 -3.609375 -1.21875 -3.703125 -1.375 C -3.796875 -1.539062 -3.84375 -1.722656 -3.84375 -1.921875 Z M -3.84375 -1.921875 ",
    id: "path3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.203125 -10.703125 L 4.203125 -3.015625 C 4.203125 -1.34375 3.828125 -0.875 2.8125 -0.875 C 1.984375 -0.875 1.59375 -1.375 1.59375 -2.3125 L 1.59375 -3.125 L 0.328125 -3.125 L 0.328125 -2.28125 C 0.328125 -0.609375 1.359375 0.203125 2.828125 0.203125 C 4.6875 0.203125 5.515625 -0.734375 5.515625 -2.984375 L 5.515625 -10.703125 Z M 4.203125 -10.703125 ",
    id: "path4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.171875 -10.921875 C 2.953125 -10.921875 1.96875 -10.4375 1.359375 -9.203125 C 0.9375 -8.34375 0.71875 -7.078125 0.71875 -5.359375 C 0.71875 -1.453125 1.875 0.203125 4.171875 0.203125 C 5.171875 0.203125 6.484375 -0.109375 7.15625 -1.921875 C 7.453125 -2.734375 7.625 -3.84375 7.625 -5.359375 C 7.625 -9.296875 6.4375 -10.921875 4.171875 -10.921875 Z M 2.09375 -5.34375 C 2.09375 -7.296875 2.28125 -8.265625 2.609375 -8.890625 C 2.9375 -9.546875 3.453125 -9.84375 4.15625 -9.84375 C 4.9375 -9.84375 5.4375 -9.515625 5.765625 -8.828125 C 6.078125 -8.1875 6.234375 -7.21875 6.234375 -5.359375 C 6.234375 -3.3125 6.046875 -2.46875 5.75 -1.84375 C 5.4375 -1.21875 4.890625 -0.875 4.171875 -0.875 C 3.453125 -0.875 2.921875 -1.1875 2.59375 -1.828125 C 2.265625 -2.453125 2.09375 -3.625 2.09375 -5.34375 Z M 2.09375 -5.34375 ",
    id: "path5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.171875 -10.921875 C 3.015625 -10.921875 2.078125 -10.46875 1.5 -9.46875 C 0.96875 -8.5625 0.71875 -7.203125 0.71875 -5.34375 C 0.71875 -2.8125 1.046875 0.203125 4 0.203125 C 5.0625 0.203125 5.984375 -0.421875 6.3125 -1.453125 L 6.34375 -1.453125 L 6.34375 0 L 7.328125 0 L 7.328125 -5.5625 L 4.015625 -5.5625 L 4.015625 -4.484375 L 6.140625 -4.484375 L 6.140625 -4.421875 C 6.140625 -1.828125 5.421875 -0.875 4.171875 -0.875 C 3.40625 -0.875 2.90625 -1.21875 2.59375 -1.84375 C 2.28125 -2.46875 2.09375 -3.4375 2.09375 -5.34375 C 2.09375 -7.265625 2.265625 -8.15625 2.5625 -8.8125 C 2.859375 -9.453125 3.34375 -9.84375 4.171875 -9.84375 C 5.265625 -9.84375 5.84375 -9.1875 5.953125 -7.75 L 5.953125 -7.734375 L 7.328125 -7.734375 C 7.3125 -9.3125 6.5625 -10.921875 4.171875 -10.921875 Z M 4.171875 -10.921875 ",
    id: "path6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.875 -10.703125 L 0.875 0 L 6.578125 0 L 6.578125 -1.171875 L 2.1875 -1.171875 L 2.1875 -5.015625 L 6.171875 -5.015625 L 6.171875 -6.1875 L 2.1875 -6.1875 L 2.1875 -9.546875 L 6.40625 -9.546875 L 6.40625 -10.703125 Z M 0.875 -10.703125 ",
    id: "path7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.875 -10.703125 L 0.875 0 L 2.1875 0 L 2.1875 -4.765625 L 4.078125 -4.765625 C 5.140625 -4.765625 5.515625 -4.140625 5.5625 -3.140625 C 5.5625 -3.09375 5.609375 -2.546875 5.65625 -1.59375 C 5.71875 -0.625 5.828125 -0.1875 6.015625 0 L 7.609375 0 C 7.171875 -0.21875 7.078125 -0.921875 7.046875 -1.359375 L 6.9375 -3.453125 C 6.90625 -4.484375 6.328125 -5.1875 5.4375 -5.296875 L 5.4375 -5.328125 C 6.546875 -5.578125 7.078125 -6.65625 7.078125 -8.03125 C 7.078125 -9.828125 5.921875 -10.703125 4.3125 -10.703125 Z M 2.1875 -5.84375 L 2.1875 -9.625 L 3.796875 -9.625 C 4.90625 -9.625 5.703125 -9.0625 5.703125 -7.90625 C 5.703125 -6.34375 4.90625 -5.84375 3.6875 -5.84375 Z M 2.1875 -5.84375 ",
    id: "path8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.875 -10.703125 L 0.875 0 L 2.1875 0 L 2.1875 -5.015625 L 6.171875 -5.015625 L 6.171875 -6.1875 L 2.1875 -6.1875 L 2.1875 -9.546875 L 6.40625 -9.546875 L 6.40625 -10.703125 Z M 0.875 -10.703125 ",
    id: "path9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.875 -10.703125 L 0.875 0 L 2.1875 0 L 2.1875 -10.703125 Z M 0.875 -10.703125 ",
    id: "path10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.125 -10.703125 L 0.125 -9.546875 L 2.8125 -9.546875 L 2.8125 0 L 4.125 0 L 4.125 -9.546875 L 6.828125 -9.546875 L 6.828125 -10.703125 Z M 0.125 -10.703125 ",
    id: "path11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-2-0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph-2-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -2.203125 5.71875 L -2.203125 1.578125 C -2.203125 0.9375 -2.0625 0.734375 -1.6875 0.734375 C -1.34375 0.734375 -1.171875 0.90625 -1.171875 1.625 L -1.171875 1.8125 L -0.125 1.8125 L -0.125 1.578125 C -0.125 0.3125 -0.703125 -0.109375 -1.625 -0.109375 C -2.875 -0.109375 -3.359375 0.453125 -3.359375 1.640625 L -3.359375 5.71875 Z M -2.203125 5.71875 ",
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -2.21875 5.828125 C -1.3125 5.828125 -0.828125 5.5 -0.546875 4.859375 C -0.3125 4.34375 -0.28125 3.5625 -0.28125 2.859375 C -0.28125 1.875 -0.34375 1.015625 -0.75 0.5 C -1.046875 0.109375 -1.46875 -0.109375 -2.21875 -0.109375 C -2.875 -0.109375 -3.28125 0.0625 -3.578125 0.34375 C -4.09375 0.859375 -4.171875 1.78125 -4.171875 2.859375 C -4.171875 3.734375 -4.125 4.515625 -3.8125 5.046875 C -3.53125 5.53125 -3.078125 5.828125 -2.21875 5.828125 Z M -1.4375 2.859375 C -1.4375 4.28125 -1.515625 4.96875 -2.21875 4.96875 C -2.9375 4.96875 -3.015625 4.28125 -3.015625 2.859375 C -3.015625 1.40625 -2.9375 0.734375 -2.21875 0.734375 C -1.515625 0.734375 -1.4375 1.421875 -1.4375 2.859375 Z M -1.4375 2.859375 ",
    id: "path29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -2.265625 5.828125 C -0.734375 5.828125 -0.34375 4.734375 -0.34375 2.90625 C -0.34375 0.75 -0.734375 -0.109375 -2.046875 -0.109375 C -2.5625 -0.109375 -2.96875 0.078125 -3.234375 0.53125 L -3.25 0.53125 L -3.25 0 L -4.109375 0 L -4.109375 3.078125 L -2.234375 3.078125 L -2.234375 2.234375 L -3 2.234375 L -3 1.65625 C -3 1.03125 -2.5625 0.734375 -2.28125 0.734375 C -1.75 0.734375 -1.5 1.234375 -1.5 2.96875 C -1.5 4.578125 -1.8125 4.96875 -2.28125 4.96875 C -2.765625 4.96875 -2.921875 4.453125 -2.9375 4.015625 L -4.046875 4.015625 C -4.046875 5.234375 -3.484375 5.828125 -2.265625 5.828125 Z M -2.265625 5.828125 ",
    id: "path30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -0.40625 5.71875 L -0.40625 0 L -3.671875 0 L -3.671875 0.9375 L -1.546875 0.9375 L -1.546875 2.484375 L -3.46875 2.484375 L -3.46875 3.421875 L -1.546875 3.421875 L -1.546875 4.765625 L -3.59375 4.765625 L -3.59375 5.71875 Z M -0.40625 5.71875 ",
    id: "path31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -0.40625 5.71875 L -0.40625 0 L -1.546875 0 L -1.546875 2.421875 L -2.1875 2.421875 C -2.59375 2.421875 -2.828125 2.1875 -2.84375 1.703125 L -2.875 0.78125 C -2.875 0.359375 -2.9375 0.125 -3.03125 0 L -4.265625 0 L -4.265625 0.046875 C -4 0.171875 -4.03125 0.765625 -4.015625 1.078125 C -3.984375 2.234375 -3.921875 2.703125 -3.09375 2.8125 L -3.09375 2.828125 C -3.703125 2.953125 -4.046875 3.421875 -4.046875 4.234375 C -4.046875 5.296875 -3.40625 5.71875 -2.53125 5.71875 Z M -1.546875 3.21875 L -1.546875 4.859375 L -2.125 4.859375 C -2.609375 4.859375 -2.890625 4.609375 -2.890625 4.078125 C -2.890625 3.484375 -2.59375 3.21875 -2.0625 3.21875 Z M -1.546875 3.21875 ",
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -0.40625 5.71875 L -0.40625 0 L -1.546875 0 L -1.546875 2.484375 L -3.46875 2.484375 L -3.46875 3.421875 L -1.546875 3.421875 L -1.546875 4.765625 L -3.59375 4.765625 L -3.59375 5.71875 Z M -0.40625 5.71875 ",
    id: "path33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -0.453125 5.71875 L -0.453125 0 L -1.609375 0 L -1.609375 5.71875 Z M -0.453125 5.71875 ",
    id: "path34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -0.09375 5.71875 L -0.09375 4.765625 L -1.34375 4.765625 L -1.34375 0 L -2.5 0 L -2.5 4.765625 L -3.75 4.765625 L -3.75 5.71875 Z M -0.09375 5.71875 ",
    id: "path35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -4.25 -1.5 C -4.25 -0.3125 -2.9375 -0.203125 -2.09375 -0.203125 L -1.859375 -0.203125 C -0.875 -0.203125 0.078125 -0.390625 0.078125 -1.46875 C 0.078125 -2.21875 -0.484375 -2.671875 -1.375 -2.671875 C -2.203125 -2.671875 -2.71875 -2.25 -2.71875 -1.5625 C -2.71875 -1.21875 -2.53125 -0.90625 -2.234375 -0.75 L -2.234375 -0.734375 L -2.59375 -0.734375 C -3 -0.734375 -3.859375 -0.859375 -3.859375 -1.484375 C -3.859375 -1.828125 -3.609375 -2.046875 -3.234375 -2.046875 L -3.234375 -2.578125 C -3.859375 -2.546875 -4.25 -2.171875 -4.25 -1.5 Z M -1.296875 -0.796875 C -1.9375 -0.796875 -2.28125 -1.03125 -2.28125 -1.46875 C -2.28125 -1.921875 -1.921875 -2.140625 -1.296875 -2.140625 C -0.671875 -2.140625 -0.3125 -1.890625 -0.3125 -1.46875 C -0.3125 -1.03125 -0.703125 -0.796875 -1.296875 -0.796875 Z M -1.296875 -0.796875 ",
    id: "path36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -4.25 -1.46875 C -4.25 -0.671875 -3.78125 -0.265625 -2.890625 -0.265625 L -2.890625 -0.796875 C -3.515625 -0.796875 -3.8125 -1.03125 -3.8125 -1.46875 C -3.8125 -1.859375 -3.484375 -2.078125 -3.046875 -2.078125 C -2.84375 -2.078125 -2.65625 -2.03125 -2.5 -1.9375 C -2.25 -1.796875 -2.0625 -1.546875 -1.921875 -1.390625 C -1.78125 -1.21875 -1.6875 -1.09375 -1.5625 -0.984375 C -1.296875 -0.703125 -1.0625 -0.53125 -0.71875 -0.390625 C -0.5 -0.296875 -0.203125 -0.25 0 -0.25 L 0 -2.625 L -0.46875 -2.625 L -0.46875 -0.796875 C -0.75 -0.875 -0.984375 -1.015625 -1.1875 -1.265625 L -1.796875 -1.96875 C -2.171875 -2.390625 -2.53125 -2.609375 -3.109375 -2.609375 C -3.78125 -2.609375 -4.25 -2.21875 -4.25 -1.46875 Z M -4.25 -1.46875 ",
    id: "path37"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.296875 -1.65625 C -3.296875 -1.3125 -3.125 -1.015625 -2.84375 -0.875 L -2.84375 -0.859375 L -3.21875 -0.859375 L -3.21875 -0.375 L 0 -0.375 L 0 -0.875 L -2.234375 -0.875 C -2.625 -0.875 -2.875 -1.140625 -2.875 -1.484375 C -2.875 -1.765625 -2.6875 -1.90625 -2.25 -1.90625 L 0 -1.90625 L 0 -2.421875 L -2.234375 -2.421875 C -2.625 -2.421875 -2.875 -2.671875 -2.875 -3.015625 C -2.875 -3.3125 -2.65625 -3.453125 -2.25 -3.453125 L 0 -3.453125 L 0 -3.953125 L -2.359375 -3.953125 C -3.109375 -3.953125 -3.296875 -3.609375 -3.296875 -3.109375 C -3.296875 -2.796875 -3.09375 -2.5 -2.796875 -2.34375 C -3.140625 -2.25 -3.296875 -2.046875 -3.296875 -1.65625 Z M -3.296875 -1.65625 ",
    id: "path38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -4.25 -1.421875 C -4.25 -0.703125 -3.796875 -0.296875 -3.03125 -0.296875 L -3.03125 -0.828125 L -3.046875 -0.828125 C -3.5625 -0.828125 -3.859375 -1.03125 -3.859375 -1.4375 C -3.859375 -1.796875 -3.59375 -1.984375 -3.140625 -1.984375 C -2.671875 -1.984375 -2.390625 -1.75 -2.390625 -1.34375 L -2.390625 -1.078125 L -2 -1.078125 L -2 -1.375 C -2 -1.828125 -1.734375 -2.125 -1.1875 -2.125 C -0.59375 -2.125 -0.3125 -1.859375 -0.3125 -1.4375 C -0.3125 -1.03125 -0.625 -0.78125 -1.15625 -0.765625 L -1.15625 -0.234375 C -0.4375 -0.234375 0.078125 -0.625 0.078125 -1.4375 C 0.078125 -2.203125 -0.40625 -2.640625 -1.234375 -2.640625 C -1.78125 -2.640625 -2.109375 -2.375 -2.21875 -1.859375 L -2.234375 -1.859375 C -2.359375 -2.296875 -2.6875 -2.515625 -3.140625 -2.515625 C -3.8125 -2.515625 -4.25 -2.15625 -4.25 -1.421875 Z M -4.25 -1.421875 ",
    id: "path39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -4.25 -1.71875 L -1.5 -0.1875 L -1.03125 -0.1875 L -1.03125 -1.71875 L 0 -1.71875 L 0 -2.21875 L -1.03125 -2.21875 L -1.03125 -2.703125 L -1.453125 -2.703125 L -1.453125 -2.21875 L -4.25 -2.21875 Z M -3.421875 -1.703125 L -3.421875 -1.71875 L -1.453125 -1.71875 L -1.453125 -0.640625 Z M -3.421875 -1.703125 ",
    id: "path40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -3.296875 -1.65625 C -3.296875 -1.3125 -3.125 -1.015625 -2.84375 -0.875 L -2.84375 -0.859375 L -3.21875 -0.859375 L -3.21875 -0.375 L 0 -0.375 L 0 -0.875 L -2.234375 -0.875 C -2.625 -0.875 -2.875 -1.140625 -2.875 -1.484375 C -2.875 -1.765625 -2.6875 -1.90625 -2.25 -1.90625 L 0 -1.90625 L 0 -2.421875 L -2.234375 -2.421875 C -2.625 -2.421875 -2.875 -2.671875 -2.875 -3.015625 C -2.875 -3.3125 -2.65625 -3.453125 -2.25 -3.453125 L 0 -3.453125 L 0 -3.953125 L -2.359375 -3.953125 C -3.109375 -3.953125 -3.296875 -3.609375 -3.296875 -3.109375 C -3.296875 -2.796875 -3.09375 -2.5 -2.796875 -2.34375 C -3.140625 -2.25 -3.296875 -2.046875 -3.296875 -1.65625 Z M -3.296875 -1.65625 ",
    id: "path41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -4.25 -1.5 C -4.25 -0.3125 -2.9375 -0.203125 -2.09375 -0.203125 L -1.859375 -0.203125 C -0.875 -0.203125 0.078125 -0.390625 0.078125 -1.46875 C 0.078125 -2.21875 -0.484375 -2.671875 -1.375 -2.671875 C -2.203125 -2.671875 -2.71875 -2.25 -2.71875 -1.5625 C -2.71875 -1.21875 -2.53125 -0.90625 -2.234375 -0.75 L -2.234375 -0.734375 L -2.59375 -0.734375 C -3 -0.734375 -3.859375 -0.859375 -3.859375 -1.484375 C -3.859375 -1.828125 -3.609375 -2.046875 -3.234375 -2.046875 L -3.234375 -2.578125 C -3.859375 -2.546875 -4.25 -2.171875 -4.25 -1.5 Z M -1.296875 -0.796875 C -1.9375 -0.796875 -2.28125 -1.03125 -2.28125 -1.46875 C -2.28125 -1.921875 -1.921875 -2.140625 -1.296875 -2.140625 C -0.671875 -2.140625 -0.3125 -1.890625 -0.3125 -1.46875 C -0.3125 -1.03125 -0.703125 -0.796875 -1.296875 -0.796875 Z M -1.296875 -0.796875 ",
    id: "path42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -0.578125 4.15625 L -0.34375 1.984375 L -0.796875 1.96875 C -0.84375 2.15625 -1.109375 2.375 -1.40625 2.375 C -1.859375 2.375 -2.109375 2 -2.109375 1.40625 C -2.109375 0.703125 -1.859375 0.3125 -1.421875 0.3125 C -1.015625 0.3125 -0.78125 0.609375 -0.765625 1.09375 L -0.234375 1.09375 C -0.265625 0.359375 -0.671875 -0.078125 -1.40625 -0.078125 C -2.203125 -0.078125 -2.640625 0.46875 -2.640625 1.375 C -2.640625 2.25 -2.21875 2.765625 -1.578125 2.765625 C -1.296875 2.765625 -1 2.65625 -0.828125 2.453125 L -0.8125 2.46875 L -0.984375 3.703125 L -2.484375 3.703125 L -2.484375 4.15625 Z M -0.578125 4.15625 ",
    id: "path43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.65625 3.296875 C -1.3125 3.296875 -1.015625 3.125 -0.875 2.84375 L -0.859375 2.84375 L -0.859375 3.21875 L -0.375 3.21875 L -0.375 0 L -0.875 0 L -0.875 2.234375 C -0.875 2.625 -1.140625 2.875 -1.484375 2.875 C -1.765625 2.875 -1.90625 2.6875 -1.90625 2.25 L -1.90625 0 L -2.421875 0 L -2.421875 2.234375 C -2.421875 2.625 -2.671875 2.875 -3.015625 2.875 C -3.3125 2.875 -3.453125 2.65625 -3.453125 2.25 L -3.453125 0 L -3.953125 0 L -3.953125 2.359375 C -3.953125 3.109375 -3.609375 3.296875 -3.109375 3.296875 C -2.796875 3.296875 -2.5 3.09375 -2.34375 2.796875 C -2.25 3.140625 -2.046875 3.296875 -1.65625 3.296875 Z M -1.65625 3.296875 ",
    id: "path44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-11-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.15625 0.578125 L 1.984375 0.34375 L 1.96875 0.796875 C 2.15625 0.84375 2.375 1.109375 2.375 1.40625 C 2.375 1.859375 2 2.109375 1.40625 2.109375 C 0.703125 2.109375 0.3125 1.859375 0.3125 1.421875 C 0.3125 1.015625 0.609375 0.78125 1.09375 0.765625 L 1.09375 0.234375 C 0.359375 0.265625 -0.078125 0.671875 -0.078125 1.40625 C -0.078125 2.203125 0.46875 2.640625 1.375 2.640625 C 2.25 2.640625 2.765625 2.21875 2.765625 1.578125 C 2.765625 1.296875 2.65625 1 2.453125 0.828125 L 2.46875 0.8125 L 3.703125 0.984375 L 3.703125 2.484375 L 4.15625 2.484375 Z M 4.15625 0.578125 ",
    id: "path45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-11-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.296875 1.65625 C 3.296875 1.3125 3.125 1.015625 2.84375 0.875 L 2.84375 0.859375 L 3.21875 0.859375 L 3.21875 0.375 L 0 0.375 L 0 0.875 L 2.234375 0.875 C 2.625 0.875 2.875 1.140625 2.875 1.484375 C 2.875 1.765625 2.6875 1.90625 2.25 1.90625 L 0 1.90625 L 0 2.421875 L 2.234375 2.421875 C 2.625 2.421875 2.875 2.671875 2.875 3.015625 C 2.875 3.3125 2.65625 3.453125 2.25 3.453125 L 0 3.453125 L 0 3.953125 L 2.359375 3.953125 C 3.109375 3.953125 3.296875 3.609375 3.296875 3.109375 C 3.296875 2.796875 3.09375 2.5 2.796875 2.34375 C 3.140625 2.25 3.296875 2.046875 3.296875 1.65625 Z M 3.296875 1.65625 ",
    id: "path46"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 4.94,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(92.939758%, 10.978699%, 14.118958%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 88.59375 1941.142188 L 88.59375 1545.009375 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(92.939758%, 10.978699%, 14.118958%)",
    fillOpacity: 1,
    d: "M 7.253906 128.671875 L 10.464844 128.671875 L 10.464844 128.179688 L 7.253906 128.179688 Z M 7.253906 128.671875 ",
    id: "path48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(92.939758%, 10.978699%, 14.118958%)",
    fillOpacity: 1,
    d: "M 7.253906 168.285156 L 10.464844 168.285156 L 10.464844 167.789062 L 7.253906 167.789062 Z M 7.253906 168.285156 ",
    id: "path49"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.939758%, 10.978699%, 14.118958%)",
    fillOpacity: 1,
    id: "g49"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 5.99883,
    y: 159.296,
    id: "use49"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.939758%, 10.978699%, 14.118958%)",
    fillOpacity: 1,
    id: "g50"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 5.99883,
    y: 155.796,
    id: "use50"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.939758%, 10.978699%, 14.118958%)",
    fillOpacity: 1,
    id: "g51"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 5.99883,
    y: 150.47601,
    id: "use51"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.939758%, 10.978699%, 14.118958%)",
    fillOpacity: 1,
    id: "g52"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 5.99883,
    y: 145.28201,
    id: "use52"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(92.378235%, 11.332703%, 15.109253%)",
    strokeOpacity: 1,
    strokeDasharray: "9.22 9.22",
    strokeMiterlimit: 4,
    d: "M 3566.40625 3106.454688 L 3566.40625 3225.439063 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(92.378235%, 11.332703%, 15.109253%)",
    strokeOpacity: 1,
    strokeDasharray: "9.22 9.22",
    strokeMiterlimit: 4,
    d: "M 2157.34375 3106.454688 L 2157.34375 3225.439063 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path53"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(100%, 100%, 100%)",
    fillOpacity: 1,
    strokeWidth: 2.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(9.257507%, 9.402466%, 9.19342%)",
    strokeOpacity: 1,
    strokeMiterlimit: 4,
    d: "M 206.054688 191.571875 L 1623.359375 191.571875 L 1623.359375 3082.9 L 206.054688 3082.9 Z M 206.054688 191.571875 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path54"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g54"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-0",
    x: 53.1836,
    y: 250.4693,
    id: "use54"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g55"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-1",
    x: 60.4736,
    y: 250.4693,
    id: "use55"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g56"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-2",
    x: 69.7136,
    y: 250.4693,
    id: "use56"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g57"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-2",
    x: 78.6686,
    y: 250.4693,
    id: "use57"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g58"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-3",
    x: 87.6236,
    y: 250.4693,
    id: "use58"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g59"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-4",
    x: 95.4686,
    y: 250.4693,
    id: "use59"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g60"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-5",
    x: 104.1536,
    y: 250.4693,
    id: "use60"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g61"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-6",
    x: 110.9036,
    y: 250.4693,
    id: "use61"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g62"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-7",
    x: 118.4636,
    y: 250.4693,
    id: "use62"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g63"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-8",
    x: 122.4236,
    y: 250.4693,
    id: "use63"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g64"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-2-0",
    x: 150.436,
    y: 116.281,
    id: "use64"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g65"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-2-0",
    x: 145.396,
    y: 116.281,
    id: "use65"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g66"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-2-0",
    x: 140.356,
    y: 116.281,
    id: "use66"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g67"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-2-0",
    x: 135.316,
    y: 116.281,
    id: "use67"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g68"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-2-1",
    x: 130.276,
    y: 116.281,
    id: "use68"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g69"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-2-0",
    x: 127.054,
    y: 116.281,
    id: "use69"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g70"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-2-0",
    x: 122.014,
    y: 116.281,
    id: "use70"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g71"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-2-0",
    x: 116.974,
    y: 116.281,
    id: "use71"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 5.63,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(85.913086%, 12.606812%, 16.711426%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 177.695312 1941.376563 L 185.703125 1941.376563 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path71"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 5.63,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(85.913086%, 12.606812%, 16.711426%)",
    strokeOpacity: 1,
    strokeDasharray: "16.02 16.02",
    strokeMiterlimit: 10,
    d: "M 201.71875 1941.376563 L 1635.742188 1941.376563 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path72"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 5.63,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(85.913086%, 12.606812%, 16.711426%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 1643.75 1941.376563 L 1651.71875 1941.376563 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path73"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 5.63,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(85.913086%, 12.606812%, 16.711426%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 177.695312 2111.454688 L 185.703125 2111.454688 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path74"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 5.63,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(85.913086%, 12.606812%, 16.711426%)",
    strokeOpacity: 1,
    strokeDasharray: "16.02 16.02",
    strokeMiterlimit: 10,
    d: "M 201.71875 2111.454688 L 1635.742188 2111.454688 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path75"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 5.63,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(85.913086%, 12.606812%, 16.711426%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 1643.710938 2111.454688 L 1651.71875 2111.454688 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path76"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g76"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-3-0",
    x: 46.0371,
    y: 114.983,
    id: "use76"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g77"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-3-1",
    x: 39.0171,
    y: 114.983,
    id: "use77"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(95.036316%, 93.591309%, 92.422485%)",
    fillOpacity: 1,
    d: "M 133.503906 203.945312 L 119.609375 167.296875 L 119.589844 167.226562 L 119.382812 167.226562 L 111.703125 188.390625 C 109.964844 186.851562 107.511719 185.894531 104.410156 185.53125 L 103.46875 185.4375 L 104.402344 185.320312 C 109.507812 184.40625 112.9375 181.179688 112.9375 177.296875 C 112.9375 171.972656 107.929688 168.253906 100.753906 168.253906 L 85.640625 168.253906 L 85.640625 168.523438 L 89.976562 168.523438 L 89.976562 195.578125 L 79.21875 167.253906 L 79.015625 167.253906 L 65.726562 203.882812 L 65.660156 203.890625 C 65.207031 203.945312 64.761719 203.972656 64.320312 203.972656 L 53.609375 203.972656 L 74.570312 168.253906 L 49.152344 168.253906 L 49.152344 179.210938 L 49.417969 179.210938 C 49.464844 173.871094 52.574219 168.519531 59.4375 168.519531 L 68.132812 168.519531 L 47.117188 204.242188 L 74.878906 204.242188 L 74.878906 193.742188 L 74.609375 193.742188 C 74.570312 198.398438 71.941406 202.816406 66.207031 203.8125 L 66.023438 203.84375 L 70.390625 191.839844 L 82.644531 191.839844 L 86.996094 203.945312 L 82.722656 203.945312 L 82.722656 204.210938 L 99.972656 204.210938 L 99.972656 203.945312 L 95.609375 203.945312 L 95.609375 185.632812 L 100.648438 185.632812 C 105.777344 185.632812 108.714844 187.925781 108.714844 191.917969 L 108.714844 195.167969 C 108.714844 195.523438 108.742188 196.050781 108.769531 196.488281 L 106.0625 203.945312 L 102.519531 203.945312 L 102.519531 204.207031 L 109.84375 204.207031 L 109.84375 203.945312 L 106.34375 203.945312 L 108.808594 197.171875 L 108.816406 197.273438 L 108.882812 197.886719 L 108.949219 198.285156 C 109.359375 200.789062 110.320312 202.625 111.789062 203.75 L 112.003906 203.902344 C 113.121094 204.683594 114.511719 205.078125 116.136719 205.078125 C 118.289062 205.078125 119.726562 204.539062 120.910156 203.277344 L 120.753906 203.121094 C 119.664062 204.125 118.746094 204.539062 117.597656 204.539062 C 115.640625 204.539062 114.617188 202.167969 114.617188 199.824219 L 114.617188 195.277344 C 114.617188 194.082031 114.441406 192.964844 114.09375 191.949219 L 114.046875 191.808594 L 123.015625 191.808594 L 127.375 203.945312 L 123.054688 203.945312 L 123.054688 204.207031 L 137.824219 204.207031 L 137.824219 203.945312 Z M 70.46875 191.570312 L 76.492188 174.984375 L 82.511719 191.570312 Z M 95.609375 185.367188 L 95.609375 168.523438 L 99.457031 168.523438 C 104.59375 168.523438 107.308594 171.574219 107.308594 177.351562 C 107.308594 183.492188 105.75 185.367188 100.648438 185.367188 Z M 113.941406 191.539062 L 113.914062 191.472656 C 113.515625 190.496094 112.9375 189.625 112.207031 188.867188 L 111.957031 188.617188 L 111.914062 188.578125 L 116.859375 174.953125 L 122.882812 191.539062 ",
    id: "path77"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g78"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-4-0",
    x: 61.0059,
    y: 279.1845,
    id: "use78"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g79"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-4-1",
    x: 68.0259,
    y: 279.1845,
    id: "use79"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g80"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-5-0",
    x: 60.161369,
    y: 289.1845,
    id: "use80"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g81"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-5-1",
    x: 65.048369,
    y: 289.1845,
    id: "use81"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g82"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-5-2",
    x: 70.439369,
    y: 289.1845,
    id: "use82"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g83"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-4-2",
    x: 84.644569,
    y: 279.1845,
    id: "use83"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g84"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-4-1",
    x: 91.664569,
    y: 279.1845,
    id: "use84"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g85"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-5-1",
    x: 83.719178,
    y: 289.1845,
    id: "use85"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g86"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-5-3",
    x: 89.110178,
    y: 289.1845,
    id: "use86"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g87"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-5-4",
    x: 94.330178,
    y: 289.1845,
    id: "use87"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g88"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-4-2",
    x: 108.219178,
    y: 279.1845,
    id: "use88"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g89"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-4-1",
    x: 115.239178,
    y: 279.1845,
    id: "use89"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g90"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-5-5",
    x: 106.713318,
    y: 289.1845,
    id: "use90"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g91"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-5-0",
    x: 113.769318,
    y: 289.1845,
    id: "use91"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g92"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-5-6",
    x: 118.656318,
    y: 289.1845,
    id: "use92"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g93"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-6-0",
    x: 149.37,
    y: 32.317,
    id: "use93"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g94"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-6-1",
    x: 138.57,
    y: 32.317,
    id: "use94"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g95"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-7-0",
    x: 151.8618,
    y: 82.7936,
    id: "use95"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g96"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-7-1",
    x: 147.6778,
    y: 82.7936,
    id: "use96"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g97"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-7-2",
    x: 142.7498,
    y: 82.7936,
    id: "use97"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g98"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-7-2",
    x: 137.8218,
    y: 82.7936,
    id: "use98"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g99"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-7-3",
    x: 132.8938,
    y: 82.7936,
    id: "use99"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g100"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-7-4",
    x: 128.5658,
    y: 82.7936,
    id: "use100"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g101"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-7-5",
    x: 123.6378,
    y: 82.7936,
    id: "use101"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g102"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-7-6",
    x: 120.0378,
    y: 82.7936,
    id: "use102"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g103"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-7-7",
    x: 115.8538,
    y: 82.7936,
    id: "use103"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    id: "g104"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-7-8",
    x: 113.3098,
    y: 82.7936,
    id: "use104"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(100%, 100%, 100%)",
    fillOpacity: 1,
    strokeWidth: 2.5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(9.257507%, 9.402466%, 9.19342%)",
    strokeOpacity: 1,
    strokeMiterlimit: 4,
    d: "M 2158.671875 191.571875 L 3575.976562 191.571875 L 3575.976562 3082.9 L 2158.671875 3082.9 Z M 2158.671875 191.571875 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path104"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 5.63,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(85.913086%, 12.606812%, 16.711426%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2130.3125 1941.376563 L 2138.28125 1941.376563 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path105"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 5.63,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(85.913086%, 12.606812%, 16.711426%)",
    strokeOpacity: 1,
    strokeDasharray: "16.02 16.02",
    strokeMiterlimit: 10,
    d: "M 2154.335938 1941.376563 L 3588.359375 1941.376563 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path106"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 5.63,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(85.913086%, 12.606812%, 16.711426%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 3596.367188 1941.376563 L 3604.335938 1941.376563 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path107"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 5.63,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(85.913086%, 12.606812%, 16.711426%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2130.3125 2111.454688 L 2138.28125 2111.454688 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path108"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 5.63,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(85.913086%, 12.606812%, 16.711426%)",
    strokeOpacity: 1,
    strokeDasharray: "16.02 16.02",
    strokeMiterlimit: 10,
    d: "M 2154.335938 2111.454688 L 3588.359375 2111.454688 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path109"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 5.63,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(85.913086%, 12.606812%, 16.711426%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 3596.367188 2111.454688 L 3604.335938 2111.454688 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path110"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(92.378235%, 11.332703%, 15.109253%)",
    strokeOpacity: 1,
    strokeDasharray: "9.22 9.22",
    strokeMiterlimit: 4,
    d: "M 2115.390625 333.329688 L 2519.804688 333.329688 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path111"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(92.378235%, 11.332703%, 15.109253%)",
    strokeOpacity: 1,
    strokeDasharray: "9.22 9.22",
    strokeMiterlimit: 4,
    d: "M 3317.265625 333.329688 L 3721.679688 333.329688 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path112"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(92.378235%, 11.332703%, 15.109253%)",
    strokeOpacity: 1,
    strokeDasharray: "9.22 9.22",
    strokeMiterlimit: 4,
    d: "M 2299.765625 500.595313 L 2299.765625 156.18125 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path113"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(92.378235%, 11.332703%, 15.109253%)",
    strokeOpacity: 1,
    strokeDasharray: "9.22 9.22",
    strokeMiterlimit: 4,
    d: "M 3430.507812 470.595313 L 3430.507812 66.18125 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path114"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.83,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(92.092896%, 11.4151%, 14.981079%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2029.375 1924.4625 L 2029.375 209.228125 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path115"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(92.092896%, 11.4151%, 14.981079%)",
    fillOpacity: 1,
    d: "M 201.523438 130.507812 L 202.9375 128.058594 L 204.351562 130.507812 ",
    id: "path116"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(92.092896%, 11.4151%, 14.981079%)",
    fillOpacity: 1,
    d: "M 201.523438 301.203125 L 202.9375 303.652344 L 204.351562 301.203125 ",
    id: "path117"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g117"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-8-0",
    x: 198.875,
    y: 221.377,
    id: "use117"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g118"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-8-1",
    x: 198.875,
    y: 218.37705,
    id: "use118"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g119"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-8-2",
    x: 198.875,
    y: 215.3771,
    id: "use119"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g120"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-8-2",
    x: 198.875,
    y: 210.925174,
    id: "use120"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.83,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(92.092896%, 11.4151%, 14.981079%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2029.375 3064.93125 L 2029.375 2135.204688 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path120"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(92.092896%, 11.4151%, 14.981079%)",
    fillOpacity: 1,
    d: "M 201.523438 16.460938 L 202.9375 14.011719 L 204.351562 16.460938 ",
    id: "path121"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(92.092896%, 11.4151%, 14.981079%)",
    fillOpacity: 1,
    d: "M 201.523438 108.605469 L 202.9375 111.050781 L 204.351562 108.605469 ",
    id: "path122"
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g122"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-9-0",
    x: 199.269,
    y: 70.053,
    id: "use122"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g123"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-9-1",
    x: 199.269,
    y: 67.053051,
    id: "use123"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g124"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-9-2",
    x: 199.269,
    y: 64.053102,
    id: "use124"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g125"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-9-2",
    x: 199.269,
    y: 59.601178,
    id: "use125"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.83,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(92.092896%, 11.4151%, 14.981079%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2029.375 2093.36875 L 2029.375 1963.954688 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path125"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(92.092896%, 11.4151%, 14.981079%)",
    fillOpacity: 1,
    d: "M 201.523438 113.617188 L 202.9375 111.171875 L 204.351562 113.617188 ",
    id: "path126"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(92.092896%, 11.4151%, 14.981079%)",
    fillOpacity: 1,
    d: "M 201.523438 125.730469 L 202.9375 128.179688 L 204.351562 125.730469 ",
    id: "path127"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g127"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-9-3",
    x: 199.063,
    y: 125.678,
    id: "use127"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g128"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-9-2",
    x: 199.063,
    y: 122.678051,
    id: "use128"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g129"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-9-2",
    x: 199.063,
    y: 118.226127,
    id: "use129"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.83,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(92.092896%, 11.4151%, 14.981079%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 3555.664062 85.439063 L 3454.453125 85.439063 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path129"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(92.092896%, 11.4151%, 14.981079%)",
    fillOpacity: 1,
    d: "M 355.152344 312.582031 L 357.597656 313.996094 L 355.152344 315.410156 ",
    id: "path130"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(92.092896%, 11.4151%, 14.981079%)",
    fillOpacity: 1,
    d: "M 345.859375 312.582031 L 343.410156 313.996094 L 345.859375 315.410156 ",
    id: "path131"
  })), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g131"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-10-0",
    x: 355.929,
    y: 317.39859,
    id: "use131"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g132"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-10-1",
    x: 352.929051,
    y: 317.39859,
    id: "use132"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g133"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-10-1",
    x: 348.477127,
    y: 317.39859,
    id: "use133"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(92.378235%, 11.332703%, 15.109253%)",
    strokeOpacity: 1,
    strokeDasharray: "9.22 9.22",
    strokeMiterlimit: 4,
    d: "M 3578.4375 180.751563 L 3578.4375 74.970313 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path133"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(92.378235%, 11.332703%, 15.109253%)",
    strokeOpacity: 1,
    strokeDasharray: "9.22 9.22",
    strokeMiterlimit: 4,
    d: "M 3703.359375 189.267188 L 3589.804688 189.267188 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path134"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.83,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(92.092896%, 11.4151%, 14.981079%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 3686.171875 213.05625 L 3686.171875 311.3375 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path135"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(92.092896%, 11.4151%, 14.981079%)",
    fillOpacity: 1,
    d: "M 370.03125 300.820312 L 368.617188 303.269531 L 367.203125 300.820312 ",
    id: "path136"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(92.092896%, 11.4151%, 14.981079%)",
    fillOpacity: 1,
    d: "M 370.03125 291.820312 L 368.617188 289.371094 L 367.203125 291.820312 ",
    id: "path137"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g137"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-11-0",
    x: 372.529,
    y: 290.3404,
    id: "use137"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g138"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-11-1",
    x: 372.52905,
    y: 293.34041,
    id: "use138"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g139"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-11-1",
    x: 372.529124,
    y: 297.792425,
    id: "use139"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(92.378235%, 11.332703%, 15.109253%)",
    strokeOpacity: 1,
    strokeDasharray: "9.22 9.22",
    strokeMiterlimit: 4,
    d: "M 2141.171875 3084.735938 L 1982.226562 3084.735938 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path139"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(92.378235%, 11.332703%, 15.109253%)",
    strokeOpacity: 1,
    strokeDasharray: "9.22 9.22",
    strokeMiterlimit: 4,
    d: "M 2141.171875 186.532813 L 1982.226562 186.532813 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path140"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(92.378235%, 11.332703%, 15.109253%)",
    strokeOpacity: 1,
    strokeDasharray: "9.22 9.22",
    strokeMiterlimit: 4,
    d: "M 2161.992188 191.571875 L 2161.992188 73.564063 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path141"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.83,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(92.092896%, 11.4151%, 14.981079%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2287.148438 92.860938 L 2185.9375 92.860938 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 322.54)",
    id: "path142"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(92.092896%, 11.4151%, 14.981079%)",
    fillOpacity: 1,
    d: "M 228.300781 311.839844 L 230.746094 313.253906 L 228.300781 314.667969 ",
    id: "path143"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(92.092896%, 11.4151%, 14.981079%)",
    fillOpacity: 1,
    d: "M 219.007812 311.839844 L 216.558594 313.253906 L 219.007812 314.667969 ",
    id: "path144"
  })), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g144"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-10-0",
    x: 229.077,
    y: 316.65992,
    id: "use144"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g145"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-10-1",
    x: 226.077051,
    y: 316.65992,
    id: "use145"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(92.378235%, 11.332703%, 15.109253%)",
    fillOpacity: 1,
    id: "g146"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-10-1",
    x: 221.625127,
    y: 316.65992,
    id: "use146"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 335.492188 268.015625 C 333.03125 268.015625 332.15625 272.035156 331.34375 275.269531 C 331.050781 274.957031 330.148438 274.015625 330.148438 274.015625 C 329.96875 273.828125 329.757812 273.890625 329.628906 274.019531 C 329.5 274.15625 329.484375 274.40625 329.628906 274.554688 C 329.636719 274.5625 330.851562 275.835938 331.273438 276.273438 C 331.390625 276.390625 331.558594 276.460938 331.722656 276.359375 C 331.898438 276.25 331.921875 276.050781 331.921875 276.050781 C 333.367188 269.28125 334.652344 268.777344 335.488281 268.777344 C 336.191406 268.777344 337.003906 269.320312 337.003906 270.410156 C 338.050781 270.410156 338.710938 271.851562 337.863281 272.746094 C 338.5625 273.097656 338.878906 273.535156 338.878906 274.085938 C 338.878906 274.640625 338.433594 275.203125 337.792969 275.203125 C 337.152344 275.203125 336.828125 274.769531 336.328125 274.769531 C 336.105469 274.769531 335.96875 274.960938 335.96875 275.152344 L 335.96875 276.515625 L 335.027344 276.515625 L 335.027344 275.15625 C 335.027344 274.941406 334.875 274.777344 334.691406 274.777344 L 334.609375 274.78125 L 333.351562 274.945312 C 333.199219 274.964844 333.058594 275.136719 333.058594 275.316406 C 333.058594 275.527344 333.222656 275.699219 333.445312 275.699219 C 333.472656 275.699219 333.511719 275.699219 333.507812 275.695312 L 334.304688 275.585938 L 334.304688 276.933594 C 334.304688 277.109375 334.488281 277.273438 334.652344 277.273438 L 336.328125 277.273438 C 336.523438 277.273438 336.691406 277.097656 336.691406 276.890625 L 336.691406 275.660156 C 337.039062 275.882812 337.527344 275.96875 337.777344 275.96875 C 338.714844 275.96875 339.609375 275.199219 339.605469 274.0625 C 339.601562 273.035156 338.851562 272.519531 338.851562 272.519531 C 339.292969 271.289062 338.582031 270.101562 337.660156 269.773438 C 337.324219 268.507812 336.292969 268.015625 335.492188 268.015625 ",
    id: "path146"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 334.441406 278.78125 C 334.441406 279.097656 334.78125 279.289062 335.335938 279.566406 C 335.777344 279.785156 336.03125 280.011719 336.03125 280.199219 C 336.03125 280.496094 335.726562 280.601562 335.4375 280.601562 C 334.992188 280.601562 334.730469 280.414062 334.589844 280 L 334.574219 279.964844 L 334.539062 279.964844 C 334.460938 279.964844 334.398438 279.96875 334.363281 280.011719 C 334.335938 280.054688 334.339844 280.109375 334.355469 280.167969 C 334.351562 280.164062 334.453125 280.59375 334.453125 280.59375 C 334.476562 280.695312 334.511719 280.714844 334.675781 280.746094 C 334.742188 280.757812 335.101562 280.824219 335.40625 280.824219 C 336.25 280.824219 336.632812 280.464844 336.632812 280.105469 C 336.632812 279.84375 336.386719 279.59375 335.855469 279.316406 L 335.613281 279.191406 C 335.246094 279.011719 335.03125 278.902344 335.03125 278.710938 C 335.03125 278.527344 335.257812 278.398438 335.582031 278.398438 C 336.007812 278.398438 336.121094 278.648438 336.171875 278.863281 L 336.179688 278.902344 L 336.222656 278.902344 C 336.316406 278.902344 336.375 278.894531 336.410156 278.855469 C 336.429688 278.832031 336.4375 278.800781 336.433594 278.765625 L 336.402344 278.394531 C 336.390625 278.277344 336.304688 278.257812 336.1875 278.234375 C 336.042969 278.207031 335.871094 278.175781 335.613281 278.175781 C 334.878906 278.175781 334.441406 278.402344 334.441406 278.78125 ",
    id: "path147"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 336.882812 279.527344 C 336.882812 280.171875 337.414062 280.824219 338.433594 280.824219 C 338.945312 280.824219 339.238281 280.699219 339.453125 280.582031 L 339.511719 280.546875 L 339.414062 280.4375 L 339.421875 280.445312 C 339.402344 280.410156 339.382812 280.40625 339.347656 280.40625 L 339.296875 280.421875 C 339.222656 280.460938 338.984375 280.574219 338.554688 280.574219 C 338.03125 280.574219 337.460938 280.214844 337.460938 279.421875 C 337.460938 278.664062 338.078125 278.398438 338.601562 278.398438 C 338.980469 278.398438 339.179688 278.539062 339.21875 278.832031 L 339.222656 278.878906 L 339.269531 278.878906 C 339.316406 278.878906 339.433594 278.878906 339.433594 278.785156 L 339.433594 278.347656 C 339.433594 278.238281 339.316406 278.222656 339.265625 278.214844 L 339.214844 278.207031 C 339.097656 278.191406 338.980469 278.175781 338.671875 278.175781 C 337.636719 278.175781 336.882812 278.742188 336.882812 279.527344 ",
    id: "path148"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 333.039062 278.207031 L 332.121094 278.214844 L 331.511719 278.203125 L 331.421875 278.203125 C 331.363281 278.203125 331.324219 278.242188 331.324219 278.300781 C 331.324219 278.328125 331.324219 278.414062 331.425781 278.414062 C 331.796875 278.414062 331.808594 278.449219 331.8125 278.597656 L 331.816406 278.6875 L 331.820312 279.085938 L 331.820312 279.941406 C 331.820312 280.082031 331.816406 280.304688 331.808594 280.488281 C 331.808594 280.539062 331.804688 280.589844 331.476562 280.589844 C 331.386719 280.589844 331.332031 280.609375 331.332031 280.703125 C 331.332031 280.730469 331.332031 280.804688 331.421875 280.804688 L 331.4375 280.804688 C 331.476562 280.800781 331.582031 280.796875 332.089844 280.796875 C 332.636719 280.796875 332.746094 280.800781 332.78125 280.804688 L 332.804688 280.804688 C 332.871094 280.804688 332.933594 280.792969 332.933594 280.703125 C 332.933594 280.597656 332.851562 280.589844 332.714844 280.589844 C 332.386719 280.589844 332.382812 280.539062 332.382812 280.488281 C 332.375 280.324219 332.371094 280.097656 332.371094 279.941406 L 332.371094 279.636719 L 332.644531 279.636719 C 333.0625 279.636719 333.109375 279.644531 333.171875 279.984375 C 333.1875 280.058594 333.246094 280.070312 333.289062 280.070312 C 333.390625 280.070312 333.402344 280.011719 333.402344 279.988281 L 333.394531 279.859375 C 333.386719 279.785156 333.378906 279.695312 333.378906 279.570312 L 333.378906 279.050781 C 333.378906 278.96875 333.289062 278.96875 333.242188 278.96875 C 333.164062 278.96875 333.144531 279.023438 333.09375 279.269531 C 333.070312 279.363281 332.894531 279.417969 332.617188 279.417969 L 332.371094 279.417969 L 332.371094 278.648438 C 332.371094 278.441406 332.40625 278.441406 332.449219 278.4375 C 332.609375 278.429688 333 278.414062 333.117188 278.414062 C 333.226562 278.414062 333.328125 278.441406 333.398438 278.488281 C 333.605469 278.625 333.714844 278.714844 333.777344 278.769531 C 333.839844 278.824219 333.875 278.855469 333.925781 278.855469 C 333.957031 278.855469 334.046875 278.855469 334.046875 278.777344 C 334.046875 278.757812 334.039062 278.738281 334.007812 278.671875 C 333.976562 278.59375 333.917969 278.464844 333.84375 278.265625 C 333.824219 278.203125 333.753906 278.203125 333.628906 278.203125 ",
    id: "path149"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 339.40625 268.894531 L 339.53125 268.894531 C 339.589844 268.894531 339.628906 268.882812 339.652344 268.867188 C 339.675781 268.851562 339.6875 268.828125 339.6875 268.796875 C 339.6875 268.765625 339.675781 268.742188 339.652344 268.726562 C 339.632812 268.707031 339.589844 268.699219 339.523438 268.699219 L 339.40625 268.699219 Z M 339.839844 269.253906 L 339.714844 269.253906 C 339.636719 269.109375 339.585938 269.027344 339.558594 269.007812 C 339.535156 268.992188 339.503906 268.980469 339.46875 268.980469 L 339.40625 268.980469 L 339.40625 269.253906 L 339.300781 269.253906 L 339.300781 268.613281 L 339.523438 268.613281 C 339.589844 268.613281 339.640625 268.617188 339.679688 268.628906 C 339.714844 268.636719 339.742188 268.65625 339.765625 268.6875 C 339.785156 268.71875 339.796875 268.75 339.796875 268.785156 C 339.796875 268.832031 339.78125 268.871094 339.75 268.90625 C 339.71875 268.941406 339.671875 268.960938 339.613281 268.964844 L 339.613281 268.96875 C 339.652344 268.976562 339.699219 269.03125 339.765625 269.128906 Z M 339.5625 269.421875 C 339.699219 269.421875 339.816406 269.371094 339.914062 269.273438 C 340.011719 269.179688 340.058594 269.058594 340.058594 268.925781 C 340.058594 268.785156 340.011719 268.671875 339.914062 268.570312 C 339.816406 268.476562 339.699219 268.429688 339.5625 268.425781 C 339.425781 268.425781 339.308594 268.476562 339.214844 268.570312 C 339.113281 268.667969 339.066406 268.785156 339.066406 268.925781 C 339.066406 269.058594 339.113281 269.175781 339.210938 269.273438 C 339.308594 269.371094 339.425781 269.421875 339.5625 269.421875 M 339.5625 268.328125 C 339.726562 268.328125 339.867188 268.386719 339.984375 268.503906 C 340.101562 268.617188 340.160156 268.757812 340.160156 268.925781 C 340.160156 269.085938 340.101562 269.226562 339.984375 269.34375 C 339.867188 269.460938 339.726562 269.519531 339.5625 269.519531 C 339.398438 269.519531 339.257812 269.460938 339.140625 269.34375 C 339.023438 269.226562 338.96875 269.089844 338.96875 268.925781 C 338.96875 268.761719 339.023438 268.617188 339.140625 268.503906 C 339.257812 268.386719 339.398438 268.328125 339.5625 268.328125 M 339.5625 268.328125 C 339.726562 268.328125 339.867188 268.386719 339.984375 268.503906 C 340.101562 268.617188 340.160156 268.757812 340.160156 268.925781 C 340.160156 269.085938 340.101562 269.226562 339.984375 269.34375 C 339.867188 269.460938 339.726562 269.519531 339.5625 269.519531 C 339.398438 269.519531 339.257812 269.460938 339.140625 269.34375 C 339.023438 269.226562 338.96875 269.089844 338.96875 268.925781 C 338.96875 268.761719 339.023438 268.617188 339.140625 268.503906 C 339.257812 268.386719 339.398438 268.328125 339.5625 268.328125 M 339.5625 269.421875 C 339.699219 269.421875 339.816406 269.371094 339.914062 269.273438 C 340.011719 269.179688 340.058594 269.058594 340.058594 268.925781 C 340.058594 268.785156 340.011719 268.671875 339.914062 268.570312 C 339.816406 268.476562 339.699219 268.429688 339.5625 268.425781 C 339.425781 268.425781 339.308594 268.476562 339.214844 268.570312 C 339.113281 268.667969 339.066406 268.785156 339.066406 268.925781 C 339.066406 269.058594 339.113281 269.175781 339.210938 269.273438 C 339.308594 269.371094 339.425781 269.421875 339.5625 269.421875 M 339.839844 269.253906 L 339.714844 269.253906 C 339.636719 269.109375 339.585938 269.027344 339.558594 269.007812 C 339.535156 268.992188 339.503906 268.980469 339.46875 268.980469 L 339.40625 268.980469 L 339.40625 269.253906 L 339.300781 269.253906 L 339.300781 268.613281 L 339.523438 268.613281 C 339.589844 268.613281 339.640625 268.617188 339.679688 268.628906 C 339.714844 268.636719 339.742188 268.65625 339.765625 268.6875 C 339.785156 268.71875 339.796875 268.75 339.796875 268.785156 C 339.796875 268.832031 339.78125 268.871094 339.75 268.90625 C 339.71875 268.941406 339.671875 268.960938 339.613281 268.964844 L 339.613281 268.96875 C 339.652344 268.976562 339.699219 269.03125 339.765625 269.128906 Z M 339.40625 268.894531 L 339.53125 268.894531 C 339.589844 268.894531 339.628906 268.882812 339.652344 268.867188 C 339.675781 268.851562 339.6875 268.828125 339.6875 268.796875 C 339.6875 268.765625 339.675781 268.742188 339.652344 268.726562 C 339.632812 268.707031 339.589844 268.699219 339.523438 268.699219 L 339.40625 268.699219 ",
    id: "path150"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 334.738281 285.347656 L 334.539062 285.347656 L 334.539062 284.003906 L 334.53125 284.003906 L 334.070312 285.347656 L 333.878906 285.347656 L 333.421875 283.984375 L 333.414062 283.984375 L 333.414062 285.347656 L 333.210938 285.347656 L 333.210938 283.742188 L 333.53125 283.742188 L 333.910156 284.878906 C 333.953125 285.003906 333.976562 285.085938 333.984375 285.117188 L 333.988281 285.117188 C 334.007812 285.054688 334.035156 284.96875 334.074219 284.859375 L 334.457031 283.742188 L 334.738281 283.742188 ",
    id: "path151"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 328.40625 287.621094 L 327.53125 287.621094 L 327.53125 288.121094 L 328.289062 288.121094 L 328.289062 288.3125 L 327.53125 288.3125 L 327.53125 289.039062 L 327.320312 289.039062 L 327.320312 287.433594 L 328.40625 287.433594 ",
    id: "path152"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 329.726562 287.902344 C 329.71875 287.800781 329.679688 287.722656 329.617188 287.671875 C 329.550781 287.621094 329.457031 287.597656 329.335938 287.59375 C 329.226562 287.59375 329.136719 287.617188 329.070312 287.65625 C 329 287.699219 328.964844 287.757812 328.964844 287.835938 C 328.964844 287.90625 328.992188 287.957031 329.046875 287.988281 C 329.097656 288.023438 329.199219 288.058594 329.351562 288.09375 C 329.484375 288.121094 329.589844 288.152344 329.675781 288.183594 C 329.757812 288.210938 329.832031 288.261719 329.890625 288.324219 C 329.953125 288.386719 329.980469 288.476562 329.980469 288.585938 C 329.980469 288.726562 329.925781 288.839844 329.816406 288.929688 C 329.707031 289.023438 329.5625 289.066406 329.386719 289.066406 C 329.160156 289.066406 328.992188 289.019531 328.878906 288.917969 C 328.769531 288.816406 328.707031 288.683594 328.699219 288.523438 L 328.902344 288.503906 C 328.914062 288.632812 328.960938 288.730469 329.050781 288.789062 C 329.140625 288.84375 329.25 288.875 329.378906 288.875 C 329.496094 288.875 329.59375 288.851562 329.664062 288.800781 C 329.738281 288.753906 329.777344 288.6875 329.777344 288.601562 C 329.777344 288.515625 329.738281 288.449219 329.660156 288.410156 C 329.585938 288.371094 329.457031 288.332031 329.277344 288.292969 C 329.09375 288.253906 328.964844 288.199219 328.882812 288.125 C 328.804688 288.054688 328.765625 287.960938 328.765625 287.847656 C 328.765625 287.722656 328.816406 287.613281 328.914062 287.53125 C 329.015625 287.445312 329.152344 287.40625 329.328125 287.40625 C 329.507812 287.40625 329.648438 287.445312 329.757812 287.53125 C 329.867188 287.613281 329.921875 287.730469 329.929688 287.886719 ",
    id: "path153"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 331.722656 288.527344 C 331.675781 288.710938 331.59375 288.847656 331.476562 288.933594 C 331.359375 289.023438 331.21875 289.066406 331.054688 289.066406 C 330.792969 289.066406 330.601562 288.984375 330.480469 288.820312 C 330.359375 288.65625 330.300781 288.457031 330.300781 288.222656 C 330.300781 287.96875 330.371094 287.765625 330.511719 287.621094 C 330.652344 287.476562 330.835938 287.40625 331.058594 287.40625 C 331.214844 287.40625 331.347656 287.445312 331.460938 287.523438 C 331.570312 287.605469 331.648438 287.71875 331.691406 287.875 L 331.484375 287.921875 C 331.449219 287.8125 331.398438 287.726562 331.324219 287.671875 C 331.253906 287.613281 331.164062 287.585938 331.054688 287.585938 C 330.882812 287.585938 330.746094 287.644531 330.65625 287.757812 C 330.566406 287.875 330.523438 288.027344 330.523438 288.222656 C 330.523438 288.445312 330.570312 288.613281 330.660156 288.722656 C 330.757812 288.832031 330.882812 288.886719 331.039062 288.886719 C 331.164062 288.886719 331.265625 288.851562 331.34375 288.78125 C 331.421875 288.714844 331.476562 288.613281 331.507812 288.476562 ",
    id: "path154"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 332.34375 287.589844 L 332.464844 287.589844 C 332.523438 287.589844 332.5625 287.582031 332.582031 287.566406 C 332.605469 287.550781 332.617188 287.527344 332.617188 287.496094 C 332.617188 287.46875 332.605469 287.445312 332.585938 287.429688 C 332.5625 287.410156 332.523438 287.402344 332.457031 287.402344 L 332.34375 287.402344 Z M 332.765625 287.941406 L 332.644531 287.941406 C 332.566406 287.800781 332.515625 287.722656 332.492188 287.703125 C 332.46875 287.683594 332.4375 287.675781 332.402344 287.675781 L 332.34375 287.675781 L 332.34375 287.941406 L 332.242188 287.941406 L 332.242188 287.320312 L 332.457031 287.320312 C 332.523438 287.320312 332.574219 287.324219 332.605469 287.332031 C 332.640625 287.34375 332.671875 287.363281 332.691406 287.390625 C 332.714844 287.421875 332.722656 287.453125 332.722656 287.488281 C 332.722656 287.53125 332.707031 287.566406 332.679688 287.601562 C 332.648438 287.636719 332.601562 287.65625 332.546875 287.660156 L 332.546875 287.664062 C 332.582031 287.671875 332.632812 287.726562 332.691406 287.820312 Z M 332.496094 288.105469 C 332.628906 288.105469 332.742188 288.054688 332.835938 287.960938 C 332.929688 287.867188 332.976562 287.753906 332.980469 287.621094 C 332.980469 287.488281 332.933594 287.375 332.835938 287.28125 C 332.742188 287.1875 332.628906 287.140625 332.496094 287.136719 C 332.363281 287.136719 332.25 287.183594 332.152344 287.28125 C 332.0625 287.375 332.015625 287.488281 332.015625 287.621094 C 332.015625 287.753906 332.0625 287.867188 332.152344 287.960938 C 332.246094 288.054688 332.363281 288.101562 332.496094 288.105469 M 332.496094 287.042969 C 332.65625 287.042969 332.792969 287.097656 332.90625 287.210938 C 333.019531 287.324219 333.074219 287.460938 333.074219 287.621094 C 333.074219 287.777344 333.019531 287.914062 332.90625 288.027344 C 332.792969 288.140625 332.65625 288.199219 332.496094 288.199219 C 332.339844 288.199219 332.199219 288.140625 332.089844 288.03125 C 331.972656 287.917969 331.917969 287.78125 331.917969 287.621094 C 331.917969 287.460938 331.972656 287.324219 332.089844 287.214844 C 332.199219 287.101562 332.339844 287.042969 332.496094 287.042969 ",
    id: "path155"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 334.683594 288.46875 L 334.894531 288.523438 C 334.851562 288.699219 334.769531 288.832031 334.65625 288.921875 C 334.539062 289.015625 334.394531 289.0625 334.230469 289.0625 C 334.054688 289.0625 333.914062 289.027344 333.804688 288.957031 C 333.695312 288.882812 333.613281 288.785156 333.554688 288.648438 C 333.496094 288.515625 333.472656 288.371094 333.472656 288.214844 C 333.472656 288.046875 333.503906 287.902344 333.566406 287.777344 C 333.632812 287.652344 333.722656 287.558594 333.84375 287.492188 C 333.960938 287.429688 334.089844 287.394531 334.230469 287.394531 C 334.394531 287.394531 334.53125 287.4375 334.640625 287.519531 C 334.746094 287.601562 334.828125 287.714844 334.871094 287.863281 L 334.660156 287.914062 C 334.621094 287.796875 334.566406 287.710938 334.496094 287.65625 C 334.425781 287.605469 334.335938 287.578125 334.230469 287.578125 C 334.101562 287.578125 334 287.609375 333.917969 287.667969 C 333.835938 287.726562 333.773438 287.804688 333.742188 287.90625 C 333.710938 288.007812 333.691406 288.109375 333.691406 288.214844 C 333.691406 288.355469 333.710938 288.472656 333.753906 288.574219 C 333.789062 288.675781 333.851562 288.753906 333.9375 288.804688 C 334.019531 288.855469 334.113281 288.878906 334.210938 288.878906 C 334.328125 288.878906 334.433594 288.84375 334.515625 288.777344 C 334.597656 288.707031 334.65625 288.605469 334.683594 288.46875 ",
    id: "path156"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 335.367188 288.238281 C 335.367188 288.503906 335.398438 288.683594 335.460938 288.769531 C 335.523438 288.855469 335.597656 288.898438 335.6875 288.898438 C 335.78125 288.898438 335.855469 288.855469 335.917969 288.769531 C 335.980469 288.679688 336.011719 288.503906 336.011719 288.238281 C 336.011719 287.972656 335.980469 287.796875 335.917969 287.710938 C 335.855469 287.625 335.777344 287.578125 335.6875 287.578125 C 335.597656 287.578125 335.523438 287.617188 335.46875 287.695312 C 335.402344 287.792969 335.367188 287.976562 335.367188 288.238281 M 335.164062 288.238281 C 335.164062 288.046875 335.183594 287.894531 335.222656 287.78125 C 335.261719 287.664062 335.320312 287.574219 335.398438 287.511719 C 335.472656 287.449219 335.570312 287.417969 335.6875 287.417969 C 335.777344 287.417969 335.851562 287.433594 335.917969 287.46875 C 335.980469 287.503906 336.035156 287.554688 336.078125 287.621094 C 336.121094 287.683594 336.152344 287.765625 336.179688 287.859375 C 336.203125 287.953125 336.214844 288.078125 336.214844 288.238281 C 336.214844 288.429688 336.195312 288.582031 336.15625 288.699219 C 336.117188 288.816406 336.058594 288.90625 335.980469 288.96875 C 335.90625 289.03125 335.808594 289.0625 335.6875 289.0625 C 335.535156 289.0625 335.410156 289.003906 335.324219 288.894531 C 335.21875 288.761719 335.164062 288.542969 335.164062 288.238281 ",
    id: "path157"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 336.703125 288.238281 C 336.703125 288.503906 336.734375 288.683594 336.796875 288.769531 C 336.859375 288.855469 336.9375 288.898438 337.027344 288.898438 C 337.117188 288.898438 337.195312 288.855469 337.253906 288.769531 C 337.316406 288.679688 337.347656 288.503906 337.347656 288.238281 C 337.347656 287.972656 337.316406 287.796875 337.253906 287.710938 C 337.195312 287.625 337.113281 287.578125 337.023438 287.578125 C 336.933594 287.578125 336.859375 287.617188 336.808594 287.695312 C 336.738281 287.792969 336.703125 287.976562 336.703125 288.238281 M 336.5 288.238281 C 336.5 288.046875 336.519531 287.894531 336.558594 287.78125 C 336.597656 287.664062 336.65625 287.574219 336.734375 287.511719 C 336.808594 287.449219 336.90625 287.417969 337.027344 287.417969 C 337.113281 287.417969 337.1875 287.433594 337.253906 287.46875 C 337.320312 287.503906 337.371094 287.554688 337.414062 287.621094 C 337.457031 287.683594 337.492188 287.765625 337.515625 287.859375 C 337.539062 287.953125 337.550781 288.078125 337.550781 288.238281 C 337.550781 288.429688 337.53125 288.582031 337.492188 288.699219 C 337.453125 288.816406 337.398438 288.90625 337.320312 288.96875 C 337.242188 289.03125 337.144531 289.0625 337.027344 289.0625 C 336.871094 289.0625 336.746094 289.003906 336.660156 288.894531 C 336.554688 288.761719 336.5 288.542969 336.5 288.238281 ",
    id: "path158"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 338.039062 288.238281 C 338.039062 288.503906 338.070312 288.683594 338.132812 288.769531 C 338.195312 288.855469 338.273438 288.898438 338.363281 288.898438 C 338.457031 288.898438 338.53125 288.855469 338.589844 288.769531 C 338.652344 288.679688 338.683594 288.503906 338.683594 288.238281 C 338.683594 287.972656 338.652344 287.796875 338.589844 287.710938 C 338.53125 287.625 338.453125 287.578125 338.359375 287.578125 C 338.269531 287.578125 338.199219 287.617188 338.144531 287.695312 C 338.074219 287.792969 338.039062 287.976562 338.039062 288.238281 M 337.835938 288.238281 C 337.835938 288.046875 337.855469 287.894531 337.894531 287.78125 C 337.933594 287.664062 337.992188 287.574219 338.070312 287.511719 C 338.148438 287.449219 338.246094 287.417969 338.363281 287.417969 C 338.449219 287.417969 338.523438 287.433594 338.589844 287.46875 C 338.65625 287.503906 338.710938 287.554688 338.75 287.621094 C 338.796875 287.683594 338.828125 287.765625 338.851562 287.859375 C 338.878906 287.953125 338.886719 288.078125 338.886719 288.238281 C 338.886719 288.429688 338.867188 288.582031 338.828125 288.699219 C 338.789062 288.816406 338.734375 288.90625 338.65625 288.96875 C 338.578125 289.03125 338.480469 289.0625 338.363281 289.0625 C 338.207031 289.0625 338.085938 289.003906 337.996094 288.894531 C 337.890625 288.761719 337.835938 288.542969 337.835938 288.238281 ",
    id: "path159"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 340.714844 288.238281 C 340.714844 288.503906 340.746094 288.683594 340.808594 288.769531 C 340.871094 288.855469 340.945312 288.898438 341.035156 288.898438 C 341.128906 288.898438 341.203125 288.855469 341.265625 288.769531 C 341.328125 288.679688 341.359375 288.503906 341.359375 288.238281 C 341.359375 287.972656 341.328125 287.796875 341.265625 287.710938 C 341.203125 287.625 341.125 287.578125 341.035156 287.578125 C 340.945312 287.578125 340.871094 287.617188 340.816406 287.695312 C 340.75 287.792969 340.714844 287.976562 340.714844 288.238281 M 340.511719 288.238281 C 340.511719 288.046875 340.53125 287.894531 340.570312 287.78125 C 340.609375 287.664062 340.667969 287.574219 340.746094 287.511719 C 340.820312 287.449219 340.917969 287.417969 341.035156 287.417969 C 341.125 287.417969 341.199219 287.433594 341.265625 287.46875 C 341.328125 287.503906 341.382812 287.554688 341.425781 287.621094 C 341.46875 287.683594 341.503906 287.765625 341.527344 287.859375 C 341.550781 287.953125 341.5625 288.078125 341.5625 288.238281 C 341.5625 288.429688 341.542969 288.582031 341.503906 288.699219 C 341.464844 288.816406 341.40625 288.90625 341.328125 288.96875 C 341.253906 289.03125 341.15625 289.0625 341.035156 289.0625 C 340.882812 289.0625 340.757812 289.003906 340.671875 288.894531 C 340.566406 288.761719 340.511719 288.542969 340.511719 288.238281 ",
    id: "path160"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 339.378906 288.238281 C 339.378906 288.503906 339.40625 288.683594 339.46875 288.769531 C 339.53125 288.855469 339.609375 288.898438 339.699219 288.898438 C 339.789062 288.898438 339.867188 288.855469 339.929688 288.769531 C 339.992188 288.679688 340.023438 288.503906 340.023438 288.238281 C 340.023438 287.972656 339.992188 287.796875 339.929688 287.710938 C 339.867188 287.625 339.789062 287.578125 339.699219 287.578125 C 339.605469 287.578125 339.535156 287.617188 339.480469 287.695312 C 339.410156 287.792969 339.378906 287.976562 339.378906 288.238281 M 339.175781 288.238281 C 339.175781 288.046875 339.191406 287.894531 339.230469 287.78125 C 339.269531 287.664062 339.328125 287.574219 339.40625 287.511719 C 339.484375 287.449219 339.582031 287.417969 339.699219 287.417969 C 339.785156 287.417969 339.863281 287.433594 339.925781 287.46875 C 339.992188 287.503906 340.046875 287.554688 340.089844 287.621094 C 340.132812 287.683594 340.164062 287.765625 340.1875 287.859375 C 340.214844 287.953125 340.226562 288.078125 340.226562 288.238281 C 340.226562 288.429688 340.207031 288.582031 340.167969 288.699219 C 340.128906 288.816406 340.070312 288.90625 339.992188 288.96875 C 339.914062 289.03125 339.816406 289.0625 339.699219 289.0625 C 339.542969 289.0625 339.421875 289.003906 339.335938 288.894531 C 339.226562 288.761719 339.175781 288.542969 339.175781 288.238281 ",
    id: "path161"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 342.050781 288.238281 C 342.050781 288.503906 342.082031 288.683594 342.144531 288.769531 C 342.203125 288.855469 342.28125 288.898438 342.375 288.898438 C 342.464844 288.898438 342.539062 288.855469 342.601562 288.769531 C 342.664062 288.679688 342.695312 288.503906 342.695312 288.238281 C 342.695312 287.972656 342.664062 287.796875 342.601562 287.710938 C 342.539062 287.625 342.464844 287.578125 342.371094 287.578125 C 342.28125 287.578125 342.207031 287.617188 342.152344 287.695312 C 342.085938 287.792969 342.050781 287.976562 342.050781 288.238281 M 341.847656 288.238281 C 341.847656 288.046875 341.867188 287.894531 341.90625 287.78125 C 341.945312 287.664062 342.003906 287.574219 342.078125 287.511719 C 342.15625 287.449219 342.257812 287.417969 342.375 287.417969 C 342.460938 287.417969 342.539062 287.433594 342.601562 287.46875 C 342.667969 287.503906 342.71875 287.554688 342.761719 287.621094 C 342.804688 287.683594 342.839844 287.765625 342.863281 287.859375 C 342.886719 287.953125 342.898438 288.078125 342.898438 288.238281 C 342.898438 288.429688 342.878906 288.582031 342.839844 288.699219 C 342.800781 288.816406 342.742188 288.90625 342.664062 288.96875 C 342.589844 289.03125 342.492188 289.0625 342.375 289.0625 C 342.21875 289.0625 342.097656 289.003906 342.007812 288.894531 C 341.898438 288.761719 341.847656 288.542969 341.847656 288.238281 ",
    id: "path162"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 335.207031 285.347656 L 335.417969 285.347656 L 335.417969 283.742188 L 335.207031 283.742188 Z M 335.207031 285.347656 ",
    id: "path163"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 337.191406 285.347656 L 336.929688 285.347656 L 336.609375 284.890625 C 336.527344 284.78125 336.480469 284.707031 336.460938 284.667969 L 336.453125 284.667969 C 336.453125 284.679688 336.296875 284.90625 335.976562 285.347656 L 335.71875 285.347656 L 336.34375 284.511719 L 335.792969 283.742188 L 336.046875 283.742188 L 336.382812 284.222656 C 336.421875 284.273438 336.449219 284.316406 336.464844 284.351562 C 336.492188 284.300781 336.644531 284.101562 336.914062 283.742188 L 337.148438 283.742188 L 336.585938 284.5 ",
    id: "path164"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 306.546875 282.21875 L 308.390625 280.441406 L 308.414062 281.339844 L 310.003906 281.328125 L 311.589844 281.320312 L 311.867188 281.222656 C 312.019531 281.171875 312.222656 281.070312 312.316406 281.007812 C 312.890625 280.605469 313.027344 279.867188 312.675781 279.09375 C 312.621094 278.984375 312.09375 278.046875 311.496094 277.011719 C 310.902344 275.980469 310.421875 275.125 310.4375 275.113281 C 310.5 275.050781 311.84375 274.296875 311.851562 274.3125 C 311.859375 274.324219 312.34375 275.164062 312.929688 276.179688 C 314.125 278.253906 314.230469 278.445312 314.386719 278.921875 C 315.003906 280.761719 314.261719 282.269531 312.492188 282.78125 C 311.953125 282.9375 311.894531 282.941406 310.128906 282.964844 L 308.433594 282.984375 L 308.398438 284.015625 ",
    id: "path165"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 300.414062 282.902344 C 299.253906 282.695312 298.414062 282.144531 298.023438 281.328125 C 297.855469 280.976562 297.800781 280.738281 297.78125 280.269531 C 297.761719 279.785156 297.8125 279.449219 297.988281 278.921875 C 298.136719 278.476562 298.316406 278.128906 299.015625 276.917969 C 299.339844 276.359375 299.597656 275.902344 299.597656 275.902344 L 298.824219 275.425781 C 298.929688 275.390625 301.28125 274.726562 301.28125 274.726562 C 301.316406 274.800781 301.898438 277.1875 301.886719 277.199219 L 301.007812 276.800781 C 300.90625 276.9375 299.757812 278.957031 299.683594 279.128906 C 299.550781 279.421875 299.492188 279.722656 299.511719 280.007812 C 299.546875 280.613281 299.875 281.011719 300.523438 281.230469 L 300.78125 281.320312 L 303.132812 281.332031 L 305.488281 281.339844 L 305.488281 282.96875 L 303.117188 282.964844 C 301 282.960938 300.710938 282.953125 300.414062 282.902344 ",
    id: "path166"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 301.253906 273.121094 C 301.222656 273.09375 303.257812 269.539062 303.527344 269.148438 C 303.824219 268.714844 304.277344 268.25 304.648438 267.992188 C 304.875 267.835938 305.316406 267.636719 305.601562 267.566406 C 306.320312 267.382812 307.152344 267.574219 307.820312 268.066406 C 308.148438 268.308594 308.636719 268.835938 308.882812 269.214844 C 309.003906 269.394531 309.378906 270.023438 309.714844 270.609375 C 310.046875 271.195312 310.328125 271.679688 310.332031 271.6875 L 311.125 271.261719 C 311.136719 271.277344 310.523438 273.714844 310.503906 273.738281 C 310.492188 273.75 308.082031 273.066406 308.058594 273.042969 L 308.878906 272.511719 C 308.878906 272.464844 307.617188 270.289062 307.464844 270.074219 C 307.074219 269.515625 306.492188 269.226562 305.980469 269.328125 C 305.574219 269.40625 305.175781 269.683594 304.902344 270.078125 C 304.828125 270.183594 304.300781 271.082031 303.722656 272.082031 C 303.148438 273.082031 302.660156 273.902344 302.644531 273.90625 C 302.171875 273.667969 301.695312 273.410156 301.253906 273.121094 ",
    id: "path167"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 305.042969 276.0625 C 304.953125 275.953125 304.820312 275.898438 304.648438 275.898438 C 304.417969 275.898438 304.257812 275.984375 304.175781 276.15625 C 304.128906 276.257812 304.097656 276.417969 304.089844 276.636719 L 303.34375 276.636719 C 303.355469 276.304688 303.417969 276.035156 303.523438 275.832031 C 303.730469 275.445312 304.089844 275.25 304.613281 275.25 C 305.023438 275.25 305.351562 275.363281 305.59375 275.59375 C 305.839844 275.820312 305.960938 276.121094 305.960938 276.496094 C 305.960938 276.785156 305.875 277.042969 305.703125 277.265625 C 305.589844 277.414062 305.402344 277.582031 305.144531 277.761719 L 304.839844 277.980469 C 304.648438 278.117188 304.519531 278.214844 304.445312 278.277344 C 304.378906 278.335938 304.316406 278.40625 304.269531 278.488281 L 305.96875 278.488281 L 305.96875 279.164062 L 303.300781 279.164062 C 303.308594 278.882812 303.371094 278.628906 303.480469 278.398438 C 303.589844 278.136719 303.847656 277.863281 304.253906 277.574219 C 304.609375 277.320312 304.835938 277.140625 304.941406 277.03125 C 305.097656 276.859375 305.179688 276.675781 305.179688 276.472656 C 305.179688 276.308594 305.132812 276.171875 305.042969 276.0625 ",
    id: "path168"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 308.101562 276.0625 C 308.011719 275.953125 307.878906 275.898438 307.710938 275.898438 C 307.476562 275.898438 307.316406 275.984375 307.234375 276.15625 C 307.183594 276.257812 307.15625 276.417969 307.148438 276.636719 L 306.402344 276.636719 C 306.414062 276.304688 306.476562 276.035156 306.582031 275.832031 C 306.789062 275.445312 307.148438 275.25 307.671875 275.25 C 308.082031 275.25 308.410156 275.363281 308.652344 275.59375 C 308.898438 275.820312 309.019531 276.121094 309.019531 276.496094 C 309.019531 276.785156 308.933594 277.042969 308.761719 277.265625 C 308.648438 277.414062 308.464844 277.582031 308.203125 277.761719 L 307.898438 277.980469 C 307.707031 278.117188 307.578125 278.214844 307.507812 278.277344 C 307.433594 278.335938 307.375 278.40625 307.328125 278.488281 L 309.027344 278.488281 L 309.027344 279.164062 L 306.359375 279.164062 C 306.367188 278.882812 306.429688 278.628906 306.539062 278.398438 C 306.648438 278.136719 306.90625 277.863281 307.3125 277.574219 C 307.667969 277.320312 307.894531 277.140625 308 277.03125 C 308.15625 276.859375 308.238281 276.675781 308.238281 276.472656 C 308.238281 276.308594 308.191406 276.171875 308.101562 276.0625 ",
    id: "path169"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 303.015625 286.78125 C 303.128906 286.679688 303.1875 286.515625 303.1875 286.292969 C 303.1875 286.074219 303.128906 285.914062 303.015625 285.820312 C 302.894531 285.726562 302.730469 285.679688 302.519531 285.679688 L 301.6875 285.679688 L 301.6875 286.9375 L 302.519531 286.9375 C 302.730469 286.9375 302.894531 286.882812 303.015625 286.78125 M 302.597656 287.671875 L 301.6875 287.671875 L 301.6875 289.207031 L 300.804688 289.207031 L 300.804688 284.933594 L 302.664062 284.933594 C 303.09375 284.933594 303.433594 285.046875 303.6875 285.265625 C 303.945312 285.488281 304.074219 285.828125 304.074219 286.289062 C 304.074219 286.792969 303.945312 287.152344 303.6875 287.359375 C 303.433594 287.566406 303.070312 287.671875 302.597656 287.671875 ",
    id: "path170"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 306.558594 287.59375 L 306.023438 285.910156 L 305.472656 287.59375 Z M 306.808594 288.328125 L 305.230469 288.328125 L 304.9375 289.207031 L 304.003906 289.207031 L 305.527344 284.933594 L 306.535156 284.933594 L 308.050781 289.207031 L 307.082031 289.207031 ",
    id: "path171"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 310.824219 286.78125 C 310.941406 286.679688 310.996094 286.515625 310.996094 286.292969 C 310.996094 286.074219 310.9375 285.914062 310.824219 285.820312 C 310.703125 285.726562 310.542969 285.679688 310.332031 285.679688 L 309.5 285.679688 L 309.5 286.9375 L 310.332031 286.9375 C 310.542969 286.9375 310.707031 286.882812 310.824219 286.78125 M 310.40625 287.671875 L 309.5 287.671875 L 309.5 289.207031 L 308.613281 289.207031 L 308.613281 284.933594 L 310.472656 284.933594 C 310.902344 284.933594 311.246094 285.046875 311.5 285.265625 C 311.753906 285.488281 311.882812 285.828125 311.882812 286.289062 C 311.882812 286.792969 311.753906 287.152344 311.5 287.359375 C 311.246094 287.566406 310.878906 287.671875 310.40625 287.671875 ",
    id: "path172"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 286.730469 288.375 L 257.078125 288.375 C 253.539062 288.375 250.664062 285.546875 250.664062 282.066406 L 250.664062 271.402344 L 280.316406 271.402344 C 283.855469 271.402344 286.730469 274.230469 286.730469 277.707031 Z M 280.316406 270.695312 L 249.960938 270.695312 L 249.960938 282.066406 C 249.960938 285.933594 253.152344 289.082031 257.078125 289.082031 L 287.4375 289.082031 L 287.4375 277.707031 C 287.4375 273.839844 284.242188 270.695312 280.316406 270.695312 ",
    id: "path173"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 254.449219 267.871094 L 254.210938 267.871094 L 254.210938 268.855469 L 254.453125 268.855469 C 254.644531 268.855469 254.757812 268.722656 254.757812 268.359375 C 254.757812 268.042969 254.660156 267.871094 254.449219 267.871094 ",
    id: "path174"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 254.777344 270.695312 L 254.433594 269.355469 L 254.210938 269.355469 L 254.210938 270.695312 L 253.542969 270.695312 L 253.542969 267.316406 L 254.511719 267.316406 C 255.078125 267.316406 255.425781 267.628906 255.425781 268.316406 C 255.425781 268.804688 255.269531 269.078125 255.03125 269.207031 L 255.46875 270.695312 Z M 253.21875 267.882812 L 252.261719 267.882812 L 252.261719 268.695312 L 253.023438 268.695312 L 253.023438 269.269531 L 252.261719 269.269531 L 252.261719 270.695312 L 251.597656 270.695312 L 251.597656 267.316406 L 253.21875 267.316406 Z M 255.617188 266.609375 L 251.371094 266.605469 C 250.59375 266.605469 249.960938 267.242188 249.960938 268.019531 L 249.960938 271.402344 L 257.03125 271.402344 L 257.03125 268.019531 C 257.03125 267.242188 256.394531 266.609375 255.617188 266.609375 ",
    id: "path175"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 283.082031 275.117188 C 283.082031 275.230469 283.050781 275.34375 282.996094 275.4375 C 282.976562 275.480469 282.941406 275.515625 282.902344 275.539062 C 282.804688 275.605469 282.695312 275.640625 282.578125 275.640625 L 273.621094 275.640625 C 273.507812 275.640625 273.394531 275.605469 273.296875 275.539062 C 273.257812 275.515625 273.222656 275.480469 273.199219 275.4375 C 273.148438 275.339844 273.121094 275.230469 273.121094 275.117188 L 273.121094 274.316406 C 273.121094 273.96875 273.390625 273.6875 273.722656 273.6875 L 274.246094 273.6875 L 274.960938 273.0625 C 275.109375 272.929688 275.339844 272.855469 275.578125 272.855469 L 280.621094 272.855469 C 280.863281 272.855469 281.089844 272.929688 281.242188 273.0625 L 281.953125 273.6875 L 282.476562 273.6875 C 282.8125 273.6875 283.082031 273.96875 283.082031 274.316406 Z M 277.695312 277.402344 C 277.578125 277.285156 277.578125 277.097656 277.695312 276.976562 C 277.8125 276.859375 278.003906 276.859375 278.121094 276.976562 L 279.058594 277.917969 C 279.175781 278.035156 279.175781 278.222656 279.058594 278.34375 L 278.121094 279.28125 C 278.0625 279.339844 277.984375 279.367188 277.90625 279.367188 C 277.832031 279.367188 277.757812 279.339844 277.695312 279.28125 C 277.578125 279.164062 277.578125 278.976562 277.695312 278.859375 L 278.125 278.429688 C 278.117188 278.429688 278.109375 278.429688 278.101562 278.429688 C 276.957031 278.429688 276.027344 279.359375 276.027344 280.5 C 276.027344 281.644531 276.957031 282.574219 278.101562 282.574219 C 279.242188 282.574219 280.171875 281.644531 280.171875 280.5 C 280.171875 280.226562 280.117188 279.957031 280.015625 279.707031 C 279.949219 279.554688 280.023438 279.378906 280.175781 279.316406 C 280.328125 279.253906 280.503906 279.324219 280.566406 279.476562 C 280.703125 279.804688 280.769531 280.148438 280.769531 280.5 C 280.769531 281.972656 279.570312 283.171875 278.101562 283.171875 C 276.628906 283.171875 275.429688 281.972656 275.429688 280.5 C 275.429688 279.027344 276.628906 277.828125 278.101562 277.828125 C 278.109375 277.828125 278.117188 277.832031 278.128906 277.832031 Z M 282.699219 286.46875 C 282.699219 286.761719 282.464844 286.996094 282.171875 286.996094 L 281.722656 286.996094 C 281.503906 286.996094 281.316406 286.863281 281.234375 286.671875 C 281.074219 286.871094 280.828125 286.996094 280.550781 286.996094 L 275.652344 286.996094 C 275.371094 286.996094 275.125 286.871094 274.964844 286.671875 C 274.882812 286.863281 274.695312 286.996094 274.476562 286.996094 L 274.027344 286.996094 C 273.738281 286.996094 273.5 286.757812 273.5 286.46875 L 273.5 284.570312 C 273.5 284.277344 273.738281 284.042969 274.027344 284.042969 L 274.476562 284.042969 C 274.515625 284.042969 274.550781 284.046875 274.585938 284.054688 C 274.375 281.710938 274.050781 278.097656 273.890625 276.460938 C 273.875 276.292969 273.996094 276.144531 274.164062 276.128906 C 274.335938 276.113281 274.480469 276.238281 274.496094 276.402344 C 274.738281 278.917969 275.375 286.097656 275.382812 286.167969 C 275.394531 286.289062 275.511719 286.386719 275.652344 286.386719 L 280.550781 286.386719 C 280.6875 286.386719 280.804688 286.289062 280.816406 286.167969 C 280.824219 286.097656 281.464844 278.917969 281.703125 276.402344 C 281.71875 276.238281 281.867188 276.113281 282.035156 276.128906 C 282.203125 276.144531 282.324219 276.292969 282.308594 276.460938 C 282.152344 278.097656 281.824219 281.710938 281.617188 284.054688 C 281.652344 284.046875 281.6875 284.042969 281.722656 284.042969 L 282.171875 284.042969 C 282.464844 284.042969 282.699219 284.28125 282.699219 284.570312 Z M 280.316406 270.695312 L 265.90625 270.695312 L 270.878906 279.136719 L 266.011719 289.078125 L 287.4375 289.078125 L 287.4375 277.707031 C 287.4375 273.839844 284.242188 270.695312 280.316406 270.695312 ",
    id: "path176"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 280.617188 274.226562 L 275.582031 274.226562 C 275.441406 274.226562 275.328125 274.113281 275.328125 273.972656 C 275.328125 273.835938 275.441406 273.722656 275.582031 273.722656 L 280.617188 273.722656 C 280.757812 273.722656 280.871094 273.835938 280.871094 273.976562 C 280.871094 274.113281 280.757812 274.226562 280.617188 274.226562 M 281.84375 274.28125 C 281.773438 274.28125 281.703125 274.253906 281.648438 274.207031 L 280.851562 273.511719 C 280.816406 273.480469 280.730469 273.445312 280.621094 273.445312 L 275.578125 273.445312 C 275.472656 273.445312 275.382812 273.480469 275.347656 273.507812 L 274.550781 274.207031 C 274.496094 274.253906 274.429688 274.28125 274.355469 274.28125 L 273.722656 274.28125 C 273.726562 274.28125 273.714844 274.292969 273.714844 274.316406 L 273.714844 275.046875 L 282.488281 275.046875 L 282.488281 274.316406 C 282.488281 274.292969 282.476562 274.28125 282.480469 274.28125 ",
    id: "path177"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 240.632812 279.710938 C 239.871094 280.828125 240.515625 282.296875 241.300781 283.042969 C 242.015625 283.722656 242.589844 283.882812 242.664062 283.902344 L 243.027344 283.203125 L 244.082031 286.082031 L 241.105469 286.6875 L 241.503906 285.953125 L 241.097656 285.726562 C 239.847656 284.910156 239.582031 283.800781 239.492188 283.457031 C 239.347656 282.859375 239.121094 281.078125 240.632812 279.710938 ",
    id: "path178"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 240.617188 279.757812 C 241.15625 280.996094 242.746094 281.234375 243.796875 280.96875 C 244.722656 280.734375 245.164062 280.351562 245.242188 280.28125 L 245.238281 280.273438 L 244.839844 279.582031 L 247.832031 280.238281 L 246.75 283.074219 L 246.347656 282.359375 L 245.957031 282.574219 C 244.597656 283.199219 243.519531 282.828125 243.179688 282.71875 C 242.597656 282.527344 240.96875 281.761719 240.617188 279.757812 ",
    id: "path179"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 245.910156 276.769531 C 245.703125 278.25 244.808594 278.957031 244.53125 279.183594 C 244.054688 279.570312 242.535156 280.527344 240.65625 279.742188 C 241.992188 279.957031 243.050781 278.75 243.394531 277.722656 C 243.703125 276.800781 243.613281 276.21875 243.59375 276.128906 L 243.585938 276.128906 L 242.789062 276.09375 L 244.949219 273.921875 L 246.757812 276.363281 L 245.945312 276.316406 ",
    id: "path180"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 236.828125 275.519531 C 236.148438 275.519531 235.59375 274.964844 235.59375 274.28125 C 235.59375 273.597656 236.148438 273.046875 236.828125 273.046875 C 237.511719 273.046875 238.066406 273.597656 238.066406 274.28125 C 238.066406 274.964844 237.511719 275.519531 236.828125 275.519531 ",
    id: "path181"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 238.519531 270.695312 C 234.054688 270.695312 230.425781 274.324219 230.425781 278.792969 C 230.421875 283.257812 234.054688 286.886719 238.519531 286.886719 C 238.757812 286.886719 238.992188 286.871094 239.226562 286.851562 L 239.28125 287.664062 L 240.761719 286.234375 L 239.105469 284.96875 L 239.167969 285.820312 C 238.953125 285.84375 238.738281 285.855469 238.519531 285.855469 C 238.175781 285.855469 237.839844 285.828125 237.511719 285.78125 L 237.476562 285.566406 L 236.707031 279.011719 C 236.601562 277.773438 237.308594 277.578125 237.746094 277.761719 L 240.199219 278.75 C 240.484375 278.867188 240.617188 278.632812 240.617188 278.632812 C 240.617188 278.632812 240.777344 278.386719 240.492188 278.207031 C 240.492188 278.207031 237.144531 275.988281 236.429688 275.855469 C 235.460938 275.671875 234.496094 276.460938 234.28125 277.488281 L 233.09375 283.308594 C 232.070312 282.082031 231.453125 280.507812 231.453125 278.792969 C 231.453125 274.894531 234.625 271.726562 238.519531 271.726562 C 240.601562 271.726562 242.472656 272.632812 243.769531 274.066406 L 244.492188 273.332031 C 243.011719 271.710938 240.882812 270.695312 238.519531 270.695312 M 234.914062 281.527344 C 235.019531 281.238281 235.179688 281.257812 235.179688 281.257812 C 235.179688 281.257812 235.320312 281.226562 235.398438 281.519531 L 236.554688 285.574219 C 235.589844 285.296875 234.710938 284.816406 233.964844 284.183594 ",
    id: "path182"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 263.804688 276.105469 C 263.785156 276.449219 263.738281 277.023438 263.714844 277.285156 C 263.484375 279.707031 262.980469 281.8125 262.214844 283.546875 C 261.894531 284.265625 261.496094 284.96875 261.140625 285.433594 L 254.617188 284.035156 C 254.710938 283.902344 254.804688 283.773438 254.871094 283.667969 C 256.140625 281.761719 256.9375 279.210938 257.183594 276.292969 C 257.214844 275.882812 257.242188 275.199219 257.246094 274.707031 Z M 264.269531 275.445312 L 256.941406 273.882812 C 256.832031 273.859375 256.710938 273.886719 256.621094 273.964844 C 256.535156 274.035156 256.488281 274.148438 256.492188 274.265625 L 256.496094 274.339844 C 256.515625 274.691406 256.488281 275.699219 256.441406 276.230469 C 256.210938 279.019531 255.453125 281.449219 254.253906 283.257812 C 254.113281 283.46875 253.90625 283.753906 253.777344 283.910156 L 253.671875 284.046875 C 253.59375 284.148438 253.570312 284.285156 253.613281 284.402344 C 253.65625 284.523438 253.757812 284.613281 253.886719 284.640625 L 261.207031 286.207031 C 261.234375 286.210938 261.257812 286.214844 261.285156 286.214844 C 261.394531 286.214844 261.507812 286.160156 261.574219 286.078125 L 261.671875 285.960938 C 262.078125 285.449219 262.53125 284.660156 262.890625 283.847656 C 263.691406 282.039062 264.214844 279.855469 264.453125 277.355469 C 264.484375 277.023438 264.546875 276.203125 264.558594 275.945312 L 264.5625 275.824219 C 264.570312 275.640625 264.445312 275.480469 264.269531 275.445312 ",
    id: "path183"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 260.292969 276.070312 L 260.296875 276.113281 C 260.359375 276.113281 260.417969 276.140625 260.464844 276.191406 C 260.527344 276.257812 260.558594 276.359375 260.550781 276.46875 C 260.539062 276.671875 260.394531 276.839844 260.226562 276.839844 L 260.222656 276.839844 C 260.160156 276.839844 260.105469 276.816406 260.054688 276.765625 C 259.992188 276.699219 259.960938 276.597656 259.96875 276.488281 C 259.980469 276.285156 260.128906 276.117188 260.292969 276.113281 Z M 260.609375 276.050781 C 260.527344 275.960938 260.414062 275.910156 260.296875 275.910156 L 260.292969 275.910156 C 260.023438 275.914062 259.789062 276.167969 259.769531 276.472656 C 259.753906 276.640625 259.808594 276.796875 259.910156 276.902344 C 259.992188 276.992188 260.105469 277.042969 260.226562 277.042969 L 260.230469 277.042969 C 260.496094 277.042969 260.730469 276.789062 260.753906 276.480469 C 260.765625 276.316406 260.714844 276.160156 260.609375 276.050781 ",
    id: "path184"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 261.144531 284.851562 L 255.246094 283.570312 C 255.183594 283.558594 255.125 283.597656 255.109375 283.660156 C 255.101562 283.71875 255.140625 283.78125 255.199219 283.792969 L 261.09375 285.074219 C 261.105469 285.074219 261.109375 285.078125 261.121094 285.078125 C 261.171875 285.078125 261.21875 285.039062 261.230469 284.984375 C 261.242188 284.925781 261.203125 284.863281 261.144531 284.851562 ",
    id: "path185"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(53.726196%, 54.510498%, 55.686951%)",
    fillOpacity: 1,
    d: "M 262.429688 270.601562 C 262.078125 270.601562 261.8125 270.523438 261.632812 270.371094 C 261.453125 270.21875 261.363281 269.957031 261.363281 269.589844 L 261.363281 269.488281 L 262.039062 269.488281 L 262.039062 269.578125 C 262.039062 269.757812 262.070312 269.890625 262.136719 269.976562 C 262.203125 270.058594 262.320312 270.101562 262.484375 270.101562 C 262.605469 270.101562 262.699219 270.066406 262.777344 269.996094 C 262.851562 269.921875 262.890625 269.820312 262.890625 269.6875 C 262.890625 269.585938 262.871094 269.496094 262.835938 269.425781 C 262.800781 269.355469 262.722656 269.292969 262.601562 269.246094 C 262.203125 269.085938 261.957031 268.980469 261.863281 268.929688 C 261.765625 268.875 261.6875 268.808594 261.621094 268.734375 C 261.554688 268.660156 261.503906 268.570312 261.464844 268.46875 C 261.429688 268.367188 261.410156 268.246094 261.410156 268.101562 C 261.410156 267.78125 261.5 267.535156 261.679688 267.367188 C 261.859375 267.199219 262.117188 267.113281 262.449219 267.113281 C 262.78125 267.113281 263.035156 267.191406 263.214844 267.34375 C 263.394531 267.492188 263.484375 267.722656 263.484375 268.03125 L 263.484375 268.109375 L 262.839844 268.109375 C 262.839844 267.777344 262.714844 267.613281 262.472656 267.613281 C 262.214844 267.613281 262.085938 267.742188 262.085938 268 C 262.085938 268.125 262.113281 268.21875 262.164062 268.28125 C 262.214844 268.347656 262.304688 268.40625 262.433594 268.457031 L 262.949219 268.683594 C 263.179688 268.777344 263.34375 268.894531 263.445312 269.027344 C 263.542969 269.164062 263.59375 269.347656 263.59375 269.570312 C 263.59375 270.257812 263.207031 270.601562 262.429688 270.601562 M 261.15625 270.535156 L 259.234375 270.535156 L 259.234375 267.179688 L 261.109375 267.179688 L 261.109375 267.734375 L 259.910156 267.734375 L 259.910156 268.523438 L 261.039062 268.523438 L 261.039062 269.078125 L 259.910156 269.078125 L 259.910156 269.980469 L 261.15625 269.980469 Z M 263.523438 266.472656 L 259.304688 266.472656 C 258.53125 266.472656 257.898438 267.105469 257.898438 267.878906 L 257.898438 271.242188 L 264.929688 271.242188 L 264.929688 267.878906 C 264.929688 267.105469 264.296875 266.472656 263.523438 266.472656 ",
    id: "path186"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWtzcall002);
export default __webpack_public_path__ + "static/media/WTZCALL002.a19aea50a1a244425691f47ed254a44b.svg";
export { ForwardRef as ReactComponent };